export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  ConnectionCursor: { input: any; output: any };
  DateTime: { input: string; output: string };
  Millisecond: { input: any; output: any };
  Money: { input: any; output: any };
  Upload: { input: any; output: any };
};

export type AddBankAccountInput = {
  bankAccountFullName: Scalars["String"]["input"];
  bankAccountNumber: Scalars["String"]["input"];
  country: Scalars["String"]["input"];
  currency: Scalars["String"]["input"];
};

export type AdditionalServicesInReservationEditInput = {
  id: Scalars["ID"]["input"];
  qty: Scalars["Float"]["input"];
  variantId: Scalars["ID"]["input"];
};

export type Address = {
  city: Scalars["String"]["output"];
  doorCode?: Maybe<Scalars["String"]["output"]>;
  floorArea?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  postalOrZipCode: Scalars["String"]["output"];
  streetAddress1: Scalars["String"]["output"];
  streetAddress2?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<ApartmentType>;
};

/** Address used for properties. */
export type AddressAbstractPayload = {
  /** City, district, suburb, town, village, or ward. */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Two-letter country code (ISO 3166-1 alpha-2). */
  country?: InputMaybe<Scalars["String"]["input"]>;
  /** Address line 1 (e.g., street, block, PO Box, or company name). */
  line1?: InputMaybe<Scalars["String"]["input"]>;
  /** Address line 2 (e.g., apartment, suite, unit, or building). */
  line2?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the entity, ex. Company Name */
  name: Scalars["String"]["input"];
  /** ZIP or postal code. */
  postal_code?: InputMaybe<Scalars["String"]["input"]>;
  /** State, county, province, prefecture, or region. */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

/** Address used for properties. */
export type AddressPayload = {
  city: Scalars["String"]["input"];
  doorCode?: InputMaybe<Scalars["String"]["input"]>;
  floorArea: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  postalOrZipCode: Scalars["String"]["input"];
  streetAddress1: Scalars["String"]["input"];
  streetAddress2?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<ApartmentType>;
};

export enum ApartmentType {
  Apartment = "APARTMENT",
  House = "HOUSE",
}

export enum AppTypeEnum {
  CustomerApp = "CUSTOMER_APP",
  WorkerApp = "WORKER_APP",
}

export type AppVersion = {
  androidVersion: Scalars["String"]["output"];
  appType: AppTypeEnum;
  iosVersion: Scalars["String"]["output"];
  webVersion: Scalars["String"]["output"];
};

export type AssignWorkerToLocalizationsDto = {
  localizationId: Scalars["String"]["input"];
};

export type Attribute = {
  additionalDescription: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  isFeatured?: Maybe<Scalars["Boolean"]["output"]>;
  isRequired?: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines if service is discountable by subscription */
  isSubscriptionDiscountApplicable?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  numericType: NumericType;
  options: Array<AttributeValue>;
  position: Scalars["Int"]["output"];
  type: AttributeType;
  wysiwygDescription: Scalars["String"]["output"];
};

export type AttributeTemplate = {
  additionalDescription: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  isFeatured?: Maybe<Scalars["Boolean"]["output"]>;
  isRequired?: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines if service is discountable by subscription */
  isSubscriptionDiscountApplicable?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  numericType: NumericType;
  options: Array<AttributeValueTemplate>;
  position: Scalars["Int"]["output"];
  type: AttributeType;
  wysiwygDescription: Scalars["String"]["output"];
};

/** Whether the attribute can only take a single value */
export enum AttributeType {
  MultipleChoice = "MULTIPLE_CHOICE",
  Numeric = "NUMERIC",
  SingleChoice = "SINGLE_CHOICE",
}

export type AttributeValue = {
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  isPriceFixed: Scalars["Boolean"]["output"];
  isSalaryEnabled: Scalars["Boolean"]["output"];
  isSubscriptionDiscountEnabled: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  price: Scalars["Int"]["output"];
  salary: Scalars["Int"]["output"];
  subscriptionDiscount: Scalars["Int"]["output"];
  /** Time consumption is a filed represented by ISO-8601 duration string. Commonly it indicates how much time it take to perform specific task. */
  timeConsumption: Scalars["String"]["output"];
};

export type AttributeValueTemplate = {
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  isPriceFixed: Scalars["Boolean"]["output"];
  isSalaryEnabled: Scalars["Boolean"]["output"];
  isSubscriptionDiscountEnabled: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  price: Scalars["Int"]["output"];
  salary: Scalars["Int"]["output"];
  subscriptionDiscount: Scalars["Int"]["output"];
  /** Time consumption is a filed represented by ISO-8601 duration string. Commonly it indicates how much time it take to perform specific task. */
  timeConsumption: Scalars["String"]["output"];
};

export type AuthenticateWithSocialMediaInput = {
  token: Scalars["String"]["input"];
};

/** Model representing authenticated user. */
export type AuthenticationDataModel = {
  access_token: Scalars["String"]["output"];
  refresh_token: Scalars["String"]["output"];
};

export type AutoCompleteResponseModel = {
  address?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  latitude?: Maybe<Scalars["Float"]["output"]>;
  longitude?: Maybe<Scalars["Float"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
};

/** availability calendar model */
export type AvailabilityCalendarModel = {
  slotDate?: Maybe<Scalars["DateTime"]["output"]>;
  slots?: Maybe<Array<SlotsModel>>;
};

export type BillingAddress = {
  /** City, district, suburb, town, village, or ward. */
  city?: Maybe<Scalars["String"]["output"]>;
  /** Two-letter country code (ISO 3166-1 alpha-2). */
  country?: Maybe<Scalars["String"]["output"]>;
  /** Email */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Address line 1 (e.g., street, block, PO Box, or company name). */
  line1?: Maybe<Scalars["String"]["output"]>;
  /** Address line 2 (e.g., apartment, suite, unit, or building). */
  line2?: Maybe<Scalars["String"]["output"]>;
  /** Name of the entity, ex. Company Name */
  name: Scalars["String"]["output"];
  /** ZIP or postal code. */
  postal_code?: Maybe<Scalars["String"]["output"]>;
  /** State, county, province, prefecture, or region. */
  state?: Maybe<Scalars["String"]["output"]>;
  /** Tax Identification (NIP) */
  taxIdentification?: Maybe<Scalars["String"]["output"]>;
};

export type BillingAddressPayload = {
  /** City, district, suburb, town, village, or ward. */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Two-letter country code (ISO 3166-1 alpha-2). */
  country?: InputMaybe<Scalars["String"]["input"]>;
  /** Email */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Address line 1 (e.g., street, block, PO Box, or company name). */
  line1?: InputMaybe<Scalars["String"]["input"]>;
  /** Address line 2 (e.g., apartment, suite, unit, or building). */
  line2?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the entity, ex. Company Name */
  name: Scalars["String"]["input"];
  /** ZIP or postal code. */
  postal_code?: InputMaybe<Scalars["String"]["input"]>;
  /** State, county, province, prefecture, or region. */
  state?: InputMaybe<Scalars["String"]["input"]>;
  /** Tax Identification (NIP) */
  taxIdentification?: InputMaybe<Scalars["String"]["input"]>;
};

/** Bundle (also known as Standalone Service) defines a essential entry point of user who is willing to purchase a specific services. This instance collects all necessary attributes and sub-services to provide a specific services to a user. */
export type Bundle = {
  additionalDescription: Scalars["String"]["output"];
  additionalTitle: Scalars["String"]["output"];
  attributes: Array<Attribute>;
  bannerRedirection: Scalars["String"]["output"];
  categoryType?: Maybe<CategoryType>;
  checkList: Array<BundleCheckList>;
  description: Scalars["String"]["output"];
  /** Photo displayed at bundle card in client application (web) */
  desktopBanner: Scalars["String"]["output"];
  enabled: Scalars["Boolean"]["output"];
  houseArea?: Maybe<HouseAreaAttribute>;
  id: Scalars["String"]["output"];
  isAdditionalTitleAndDescriptionEnabled: Scalars["Boolean"]["output"];
  isBanner: Scalars["Boolean"]["output"];
  /** Determines if bundle is featured (displayed at homepage) */
  isFeatured: Scalars["Boolean"]["output"];
  isHouseAreaEnabled: Scalars["Boolean"]["output"];
  /** Price of labor for bundle's services. */
  laborPrice: Scalars["Int"]["output"];
  /** Determines if bundle minimum order value */
  minimumOrderValue?: Maybe<Scalars["Int"]["output"]>;
  /** Determines if bundle requires minimum order value to proceed to checkout */
  minimumOrderValueEnabled: Scalars["Boolean"]["output"];
  /** Image for mobile devices. */
  mobileBanner: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  services: Array<Service>;
  slug: Scalars["String"]["output"];
  startingPrice?: Maybe<Scalars["Int"]["output"]>;
  startingPriceWithCurrency?: Maybe<Scalars["String"]["output"]>;
  subscriptionOptions?: Maybe<Array<SubscriptionOption>>;
};

export type BundleCheckList = {
  description?: Maybe<Scalars["String"]["output"]>;
  iconUrl?: Maybe<Scalars["String"]["output"]>;
  position?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type BundleCheckListPayload = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  iconUrl?: InputMaybe<Scalars["String"]["input"]>;
  position?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Cancellation is a entity defining process of Customer who have decided to
 * cancel his reservation with or without given fee.
 */
export type Cancellation = {
  amount: Scalars["Int"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  invoiceId?: Maybe<Scalars["String"]["output"]>;
  paidAt?: Maybe<Scalars["DateTime"]["output"]>;
  payment?: Maybe<Payment>;
  reservationId: Scalars["String"]["output"];
  status: CancellationStatus;
  updatedAt: Scalars["DateTime"]["output"];
  voidedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CancellationFee = {
  amount: Scalars["Int"]["output"];
  currency: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  type: ProcessingFeeType;
};

export enum CancellationStatus {
  Fulfilled = "FULFILLED",
  NotFulfilled = "NOT_FULFILLED",
  RequiresAction = "REQUIRES_ACTION",
}

export type CategoryCustomerModel = {
  bannerRedirection: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  /** Image that will be shown in category details */
  desktopBannerUrl: Scalars["String"]["output"];
  desktopUrl: Scalars["String"]["output"];
  extraDesktopUrl: Scalars["String"]["output"];
  extraMobileUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isBanner: Scalars["Boolean"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  localizationId: Scalars["String"]["output"];
  /** Image that will be shown in category details */
  mobileBannerUrl: Scalars["String"]["output"];
  mobileUrl: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  slug: Scalars["String"]["output"];
  startingPrice: Scalars["Int"]["output"];
};

export enum CategoryType {
  Cleaning = "CLEANING",
  Massage = "MASSAGE",
  Other = "OTHER",
}

/** Channel of communication can be in two states: ACTIVE or ARCHIVED. */
export enum ChannelState {
  /** Channel is active, users can send messages. */
  Active = "ACTIVE",
  /** Channel is archived, users can't send messages. Read-only. */
  Archived = "ARCHIVED",
}

/** Channel represents a conversation between two or more users. The channel is about the order, not generally a conversation about specific users. To create a channel between two or more users there must be a specific deal between them. */
export type ChatChannel = {
  hasUnreadMessages: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  messages?: Maybe<Array<ChatMessage>>;
  order: ReservationVm;
  participants: Array<ChatParticipant>;
  state: ChannelState;
};

export type ChatMessage = {
  attachments?: Maybe<Array<Scalars["String"]["output"]>>;
  author?: Maybe<ChatParticipant>;
  content: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  isSystemMessage: Scalars["Boolean"]["output"];
  state: MessageState;
};

export type ChatMessageInput = {
  attachments?: InputMaybe<Array<Scalars["String"]["input"]>>;
  channelId: Scalars["String"]["input"];
  content: Scalars["String"]["input"];
};

/** Chat participant view model */
export type ChatParticipant = {
  avatar?: Maybe<Scalars["String"]["output"]>;
  isSystemParticipant?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  profileId?: Maybe<Scalars["String"]["output"]>;
};

export type Checkout = {
  address?: Maybe<Address>;
  attributes: Array<Maybe<OrderAttribute>>;
  billingAddress?: Maybe<BillingAddress>;
  bundle: Bundle;
  couponCode?: Maybe<Scalars["String"]["output"]>;
  currency: Scalars["String"]["output"];
  customerNote?: Maybe<Scalars["String"]["output"]>;
  discounts: Array<Maybe<OrderDiscount>>;
  /** A device fingerprint or machine fingerprint is information collected about the software and hardware of a remote computing device for the purpose of identification. Used for analytics. */
  fingerprint?: Maybe<Scalars["String"]["output"]>;
  /**
   * Value of meters contained in customer's possession.
   * @deprecated Field become deprecated as houseArea was added to Address object, this field will remain for backward compatibility but it's always overwritten by houseArea provided in addresses.
   */
  houseArea?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["String"]["output"];
  locationId: Scalars["String"]["output"];
  orderHouseArea?: Maybe<OrderHouseArea>;
  paymentMethodId?: Maybe<Scalars["String"]["output"]>;
  /** Subscription is non-nullable field that indicates if some reservation is cyclic or non-cyclic. */
  periodicity?: Maybe<OrderPeriodicity>;
  priceAfterDiscounts?: Maybe<Scalars["Int"]["output"]>;
  processingFees?: Maybe<Array<OrderProcessingFee>>;
  propertyId?: Maybe<Scalars["String"]["output"]>;
  services: Array<Maybe<OrderService>>;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Time consumption is a filed represented by ISO-8601 duration string. Commonly it indicates how much time it take to perform specific task. Summarized Value for given variant. */
  timeConsumption: Scalars["String"]["output"];
  totalPrice: Scalars["Int"]["output"];
  useVirtualWallet?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Model representing core information about checkout confirmation such as reservation or subscription created in process of checkout. */
export type CheckoutConfirmation = {
  id: Scalars["String"]["output"];
  type: CheckoutConfirmationType;
};

/** Type of checkout confirmation */
export enum CheckoutConfirmationType {
  Reservation = "RESERVATION",
  Subscription = "SUBSCRIPTION",
}

export type CheckoutPayload = {
  address?: InputMaybe<AddressPayload>;
  attributes: Array<InputMaybe<OrderAttributePayload>>;
  /** Some checkouts may be created with intention to get a invoice for them, in this case we should provide separate billing address. By default this will generate an invoice and send it to customer. */
  billingAddress?: InputMaybe<BillingAddressPayload>;
  bundleId: Scalars["String"]["input"];
  couponCode?: InputMaybe<Scalars["String"]["input"]>;
  customerNote?: InputMaybe<Scalars["String"]["input"]>;
  /** Value of meters contained in a customer's possession. */
  houseArea?: InputMaybe<Scalars["Int"]["input"]>;
  locationId: Scalars["String"]["input"];
  paymentMethodId?: InputMaybe<Scalars["String"]["input"]>;
  propertyId?: InputMaybe<Scalars["String"]["input"]>;
  services: Array<InputMaybe<OrderServicePayload>>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** For every subscriptionOptionId is required to define is some subscription is cyclic or not. */
  subscriptionOptionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type Country = {
  countryCode: Scalars["String"]["output"];
  currency: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  locale: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type CreateCustomerProfileInput = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  registerType: Scalars["String"]["input"];
};

export type CreateOrUpdateWorkerAddressInput = {
  city: Scalars["String"]["input"];
  extraInformation?: InputMaybe<Scalars["String"]["input"]>;
  postalOrZipCode: Scalars["String"]["input"];
  streetAddress1: Scalars["String"]["input"];
  streetAddress2?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreatePropertyInput = {
  city: Scalars["String"]["input"];
  doorCode?: InputMaybe<Scalars["String"]["input"]>;
  floorArea: Scalars["Int"]["input"];
  localizationId: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  postalOrZipCode: Scalars["String"]["input"];
  setDefault: Scalars["Boolean"]["input"];
  streetAddress1: Scalars["String"]["input"];
  streetAddress2: Scalars["String"]["input"];
  type: ApartmentType;
};

export type CreateWorkerDayOffInput = {
  endDate: Scalars["DateTime"]["input"];
  startDate: Scalars["DateTime"]["input"];
};

export type CreateWorkerProfileInput = {
  dateOfBirth: Scalars["DateTime"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  registerType: RegisterTypeEnum;
  workerAddress: CreateOrUpdateWorkerAddressInput;
};

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars["ConnectionCursor"]["input"]>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars["ConnectionCursor"]["input"]>;
  /** Paginate first */
  first?: InputMaybe<Scalars["Int"]["input"]>;
  /** Paginate last */
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** CustomerMetadata */
export type CustomerMetadata = {
  invoiceData?: Maybe<BillingAddress>;
  paymentsMetadata?: Maybe<PaymentsMetadataModel>;
  properties?: Maybe<Array<CustomerPropertyModel>>;
  stats?: Maybe<CustomerStatsModel>;
};

/** Customer Property */
export type CustomerPropertyModel = {
  city: Scalars["String"]["output"];
  customerId?: Maybe<Scalars["String"]["output"]>;
  doorCode?: Maybe<Scalars["String"]["output"]>;
  floorArea: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  isCustomerDefault: Scalars["Boolean"]["output"];
  localizationId?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  postalOrZipCode: Scalars["String"]["output"];
  streetAddress1: Scalars["String"]["output"];
  streetAddress2?: Maybe<Scalars["String"]["output"]>;
  type: ApartmentType;
};

/** CustomerStatsModel */
export type CustomerStatsModel = {
  lastPaymentFromStripe?: Maybe<Scalars["Int"]["output"]>;
  lastPaymentFromSystem?: Maybe<Scalars["Int"]["output"]>;
  totalBalance?: Maybe<Scalars["Int"]["output"]>;
  totalStripePayments?: Maybe<Scalars["Int"]["output"]>;
  totalSystemPayments?: Maybe<Scalars["Int"]["output"]>;
};

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars["DateTime"]["input"]>;
  gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  in?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  neq?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars["DateTime"]["input"];
  upper: Scalars["DateTime"]["input"];
};

export type DefineAuthorizationChallengeInput = {
  phone_number: Scalars["String"]["input"];
};

export type DeletePropertyInput = {
  apartmentId: Scalars["String"]["input"];
};

export type DeleteWorkerDayOffInput = {
  id: Scalars["String"]["input"];
};

export type DetachPushNotificationDeviceInput = {
  /** Expo device token */
  deviceToken: Scalars["String"]["input"];
};

export type DiscountReceipt = {
  discountCode: Scalars["String"]["output"];
  discountType: StoredDiscountType;
  discountValue: Scalars["Int"]["output"];
};

export enum DiscountState {
  Active = "ACTIVE",
  Used = "USED",
}

/** Payload for additional edit. */
export type EstimateReservationAdditionalServiceEditInput = {
  services: Array<AdditionalServicesInReservationEditInput>;
};

export type EstimateReservationAdditionalServiceEditResponse = {
  additional: Array<OrderService>;
  additionalChanged: Scalars["Boolean"]["output"];
  baseWage: Scalars["Int"]["output"];
  isCustomSalary: Scalars["Boolean"]["output"];
  newPrice: Scalars["Int"]["output"];
  newTimeConsumption: Scalars["String"]["output"];
  oldPrice: Scalars["Int"]["output"];
  oldTimeConsumption: Scalars["String"]["output"];
  totalLaborPrice: Scalars["Int"]["output"];
};

/** Payload for question answers edit. */
export type EstimateReservationAttributeEditInput = {
  attributes: Array<QuestionAnswersInReservationEditInput>;
};

export type EstimateReservationAttributeEditResponse = {
  baseWage: Scalars["Int"]["output"];
  isCustomSalary: Scalars["Boolean"]["output"];
  newPrice: Scalars["Int"]["output"];
  newTimeConsumption: Scalars["String"]["output"];
  oldPrice: Scalars["Int"]["output"];
  oldTimeConsumption: Scalars["String"]["output"];
  questions: Array<OrderAttribute>;
  totalLaborPrice: Scalars["Int"]["output"];
};

/** Payload for reschedule. */
export type EstimateReservationRescheduleInput = {
  startDate: Scalars["DateTime"]["input"];
};

export type File = {
  checksum: Scalars["String"]["output"];
  encoding: Scalars["String"]["output"];
  fileName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type FulfilledSwap = Swap & {
  fromReservation: ReservationVm;
  id: Scalars["ID"]["output"];
  /** Payment is not required as reservation changes may be free of charge under specific circumstances. */
  payment?: Maybe<Payment>;
  /** CompletedSwap ensures that created Reservation exists. */
  toReservation: ReservationVm;
};

export type GenerateAutocompleteForAddressInput = {
  address: Scalars["String"]["input"];
};

export type GetAvailabilityCalendarForReservationInput = {
  endDate: Scalars["DateTime"]["input"];
  locationId: Scalars["String"]["input"];
  reservationId?: InputMaybe<Scalars["String"]["input"]>;
  startDate: Scalars["DateTime"]["input"];
  timeConsumption: Scalars["String"]["input"];
  workerId?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetHomepageBannerByLocalizationIdInput = {
  localizationId: Scalars["String"]["input"];
};

/** Group by */
export enum GroupBy {
  Day = "DAY",
  Month = "MONTH",
  Week = "WEEK",
  Year = "YEAR",
}

export type HomepageBanner = {
  buttonText: Scalars["String"]["output"];
  carousel: Array<V2HomepageBannerCarousel>;
  description: Scalars["String"]["output"];
  desktopImgUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isButtonVisible: Scalars["Boolean"]["output"];
  isDescriptionVisible: Scalars["Boolean"]["output"];
  isTitleVisible: Scalars["Boolean"]["output"];
  isUrlVisible: Scalars["Boolean"]["output"];
  localization: LocalizationForHomepageBanner;
  mobileImgUrl: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type HouseAreaAttribute = {
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  /** Defines if service is discountable by subscription */
  isSubscriptionDiscountApplicable?: Maybe<Scalars["Boolean"]["output"]>;
  steps: Array<HouseAreaStep>;
};

export type HouseAreaAttributeTemplate = {
  id: Scalars["String"]["output"];
  steps: Array<HouseAreaStepTemplate>;
};

export type HouseAreaStep = {
  from: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  price: Scalars["Int"]["output"];
  timeConsumption: Scalars["String"]["output"];
  to: Scalars["Int"]["output"];
};

export type HouseAreaStepTemplate = {
  from: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  price: Scalars["Int"]["output"];
  timeConsumption: Scalars["String"]["output"];
  to: Scalars["Int"]["output"];
};

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars["ID"]["input"]>;
  gt?: InputMaybe<Scalars["ID"]["input"]>;
  gte?: InputMaybe<Scalars["ID"]["input"]>;
  iLike?: InputMaybe<Scalars["ID"]["input"]>;
  in?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<Scalars["ID"]["input"]>;
  lt?: InputMaybe<Scalars["ID"]["input"]>;
  lte?: InputMaybe<Scalars["ID"]["input"]>;
  neq?: InputMaybe<Scalars["ID"]["input"]>;
  notILike?: InputMaybe<Scalars["ID"]["input"]>;
  notIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  notLike?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The Issue type is an entity that represents an existing problem or discrepancy that occurs among a worker, an order, and a customer. This entity is primarily used for listing problems related to order modifications, although it can encapsulate issues that arise for various reasons within our system. */
export type Issue = {
  actions?: Maybe<Array<IssueAction>>;
  code: IssueDefinitionCode;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  orderId: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  workerId: Scalars["String"]["output"];
};

/** The IssueAction type represents an action that can be undertaken to resolve an issue within the system. It provides information about possible resolution steps that can be taken to address the corresponding issue. */
export type IssueAction = {
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

/** IssueDefinitionCode */
export enum IssueDefinitionCode {
  OrderCancelled = "ORDER_CANCELLED",
  OrderModified = "ORDER_MODIFIED",
}

/** JobOffer was introduced to decouple Order's model from both responsibilities of being provided to Customer and Worker. Job is another entity in our system which provides a entire routing for applying to orders and subscriptions - from front-end side we’ll ask only for Job's ID when applying. */
export type JobOffer = {
  customer: JobOfferCustomer;
  id: Scalars["String"]["output"];
  isHotJobOffer?: Maybe<Scalars["Int"]["output"]>;
  order: JobOfferOrder;
  /** Total reward for worker, used only in Poland */
  reward?: Maybe<Scalars["Int"]["output"]>;
  /** Currency of the job reward for worker, used only in Poland */
  rewardCurrency?: Maybe<Scalars["String"]["output"]>;
  status: JobStatus;
  /** Date of subscription creation */
  subscriptionCreatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  type: JobType;
  /** List of workers assigned to the job. */
  workers: Array<JobOfferWorker>;
  /** Number of workers needed to complete the job. Default is 1. Currently this feature is not perceived as a business requirements. */
  workersNeeded: Scalars["Int"]["output"];
};

export type JobOfferCustomer = {
  avatar?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type JobOfferOrder = {
  address: Address;
  attributes: Array<OrderAttribute>;
  bundle: Bundle;
  /** Subscription is non-nullable field that indicates if some reservation is cyclic or non-cyclic. */
  periodicity: OrderPeriodicity;
  /** Can be nullable as JobOffer contain shared properties from subscriptions and reservations, if JobOffer is cyclic reservationId most likely will be provided. */
  reservationId?: Maybe<Scalars["String"]["output"]>;
  services: Array<OrderService>;
  startDate: Scalars["DateTime"]["output"];
  /** When job is a subscription this filed indicated subscription ID. */
  subscriptionId?: Maybe<Scalars["String"]["output"]>;
  /** Time consumption is a filed represented by ISO-8601 duration string. Commonly it indicates how much time it take to perform specific task. */
  timeConsumption: Scalars["String"]["output"];
  /** Date of single-time reservation to end. */
  to?: Maybe<Scalars["DateTime"]["output"]>;
};

export type JobOfferWorker = {
  avatar?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  phoneNumber: Scalars["String"]["output"];
};

export enum JobStatus {
  Closed = "CLOSED",
  Open = "OPEN",
}

export enum JobType {
  /** Single-time reservation. */
  OneTime = "ONE_TIME",
  /** Recurring reservation. */
  Recurring = "RECURRING",
}

export type ListChatChannelsForReservationsInput = {
  orderIds: Array<Scalars["String"]["input"]>;
};

export type LocalizationForHomepageBanner = {
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

/** helper for localization items with pagination  */
export type LocalizationModelItems = {
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  timezone?: Maybe<Scalars["String"]["output"]>;
};

/** localization with pagination  */
export type LocalizationPaginationModel = {
  items: Array<LocalizationModelItems>;
  meta: MetadataForLocalizationPagination;
};

/** MessageState represents state of message on its lifecycle. */
export enum MessageState {
  /** Message is delivered, but not read. */
  Delivered = "DELIVERED",
  /** Message is read. Final state of things that can happen with message. */
  Read = "READ",
  /** Message is sent, but not delivered. */
  Sent = "SENT",
}

/** helper for localization with pagination  */
export type MetadataForLocalizationPagination = {
  currentPage: Scalars["Int"]["output"];
  itemCount: Scalars["Int"]["output"];
  itemsPerPage: Scalars["Int"]["output"];
  totalItems?: Maybe<Scalars["Int"]["output"]>;
  totalPages?: Maybe<Scalars["Int"]["output"]>;
};

/** helper for profile with pagination  */
export type MetadataForProfilePagination = {
  currentPage: Scalars["Int"]["output"];
  itemCount: Scalars["Int"]["output"];
  itemsPerPage: Scalars["Int"]["output"];
  totalItems?: Maybe<Scalars["Int"]["output"]>;
  totalPages?: Maybe<Scalars["Int"]["output"]>;
};

/** helper for reviews with pagination  */
export type MetadataForReviewsPagination = {
  currentPage: Scalars["Int"]["output"];
  itemCount: Scalars["Int"]["output"];
  itemsPerPage: Scalars["Int"]["output"];
  totalItems: Scalars["Int"]["output"];
  totalPages: Scalars["Int"]["output"];
};

/** helper for vounchers with pagination  */
export type MetadataForVouchersPagination = {
  currentPage: Scalars["Int"]["output"];
  itemCount: Scalars["Int"]["output"];
  itemsPerPage: Scalars["Int"]["output"];
  totalItems?: Maybe<Scalars["Int"]["output"]>;
  totalPages?: Maybe<Scalars["Int"]["output"]>;
};

export type Mutation = {
  acceptReservation: ReservationVm;
  /**
   * Accept completion of order submitted by a worker.
   *
   * [RequiresCustomerActionException](https://github.com/Stepapp/Backend/blob/2c12419a3502500206f0c9a221f1df32d877c1e5/e2e/tests/main.stepci.yaml#L4497-L4545)
   */
  acceptWorkSubmission: Reservation;
  addWorkerBankAccount: Scalars["Boolean"]["output"];
  /** Apply to a specific job as a worker. For current workflow needs this will instantly attach worker to a specific Order or Subscription. */
  applyForJob: JobOffer;
  assignWorkerToLocalization: Scalars["Boolean"]["output"];
  attachDeviceToUser: Scalars["Boolean"]["output"];
  authenticateWithFacebook: AuthenticationDataModel;
  authenticateWithGoogle: AuthenticationDataModel;
  /** Authorization of payment is a first step of payment process from user's perspective, it allows user to get known about payment status and what's else needed to complete a payment like 3D Secure Verification. Once payment is authorized it can be continued within usage of confirmPayment mutation. It's important to handle the additional steps when payment status is REQUIRES_ACTION. */
  authorizePayment: Payment;
  /** @deprecated Mutation was modified to use createCancellation and finalizeCancellation mutations which are recommended to be used since now, this mutation becomes deprecated and will be removed in the future. Fee model was split into modification and cancellation fees - as they are same no action is required for now but it's highly recommended to use getCancellationFee query instead current one which is too generic. */
  cancelReservation: ReservationVm;
  /** Cancel a subscription, this will cancel only creating a new iterations. */
  cancelSubscription: Subscription;
  /** @deprecated Mutation is going to be replaced in future, it's recommended to use 'updatePayment' instead. This mutation proxies to 'updatePayment' which now contain functionality of changing paymentMethodId as you know it. */
  changePaymentMethod: Payment;
  /**
   *
   *                The `verifyCheckoutPaymentMethod` mutation is responsible for verifying the payment method associated with a checkout process. It performs several checks and validations to ensure the integrity of the payment process.
   *
   *                Preconditions:
   *                 - The checkout must have a customer associated with it.
   *                 - The customer must have a Stripe account.
   *                 - A payment method must be provided.
   *                 - The checkout must be created.
   *
   *                 Outcomes:
   *                 - If the payment method is valid, the mutation returns a boolean indicating whether additional actions are required.
   *                 - If additional actions are required, the mutation returns the necessary data to perform them.
   *                 - If the payment method is invalid, the mutation returns an error.
   *                 - If the payment method is valid, the mutation returns a boolean indicating whether additional actions are required.
   *                 - If additional actions are required, the mutation returns the necessary data to perform them.
   *
   */
  checkoutPaymentVerification: VerifyCheckoutPaymentMethodOutput;
  /** Finalize additional edit */
  completeAdditionalEdit: FulfilledSwap;
  /** Finalize attribute edit */
  completeAttributeEdit: FulfilledSwap;
  /** Once payments are confirmed or captured, they may result in authentication errors (3DS). Authentication is made outside our server and we listed for updates from 3rd-parties, this mutation will invoke direct check of information from 3rd-parties without need to wait for server to receive webhook. */
  completeAuthorization: Payment;
  /** Finalize reschedule */
  completeReschedule: FulfilledSwap;
  /**
   * Operation will finalize process of Swap, which will result in new reservation for user and cancellation of old one.
   * When payment attached to Swap will not be paid at moment of completion - exception will be thrown.
   *
   *
   * Read more:
   * - https://github.com/Stepapp/Backend/blob/main/docs/Domain/entities/%F0%9F%94%84%20Swap.md
   *
   */
  completeSwap: FulfilledSwap;
  /** Perform checkout process which will either create a subscription or an order. */
  confirmCheckout: CheckoutConfirmation;
  confirmPayment: Payment;
  /** Complete the setup of a payment method for 'off-session' use. This mutation exists to "force" confirmation without waiting for information from webhook - it's intended for synchronous flow and it's not recommended to be implemented in client applications due to not necessary delay. */
  confirmPaymentMethodSetup: PaymentMethodSetupCompleted;
  /** Create Cancellation of Reservation, this will create a new cancellation and attempt to charge you for this action, sometimes 3DS is required you are supposed to handle it and use finalizeConfirmation */
  createCancellation: Cancellation;
  createCustomerProfile: Scalars["Boolean"]["output"];
  /** Use a payment method token to add payment method to Stripe Account */
  createPaymentMethod: Scalars["String"]["output"];
  createProperty: Scalars["Boolean"]["output"];
  createReview: Review;
  createWorkerDayOff: Scalars["Boolean"]["output"];
  createWorkerProfile: Scalars["Boolean"]["output"];
  /** reschedules reservation to selected date */
  declareRescheduleReservation?: Maybe<SwapDeclared>;
  /** changes additional to selected date */
  declareReservationAdditionalEdit?: Maybe<SwapDeclared>;
  /** changes additional to selected date */
  declareReservationAttributeEdit?: Maybe<SwapDeclared>;
  /**
   * Initiates the process of replacing an existing reservation with a new reservation, based on modifications provided in the Checkout object.
   *
   * Detailed Process:
   * - First, compute the ReplacementCheckout based on the provided changes.
   * - Use the 'declareSwap' mutation to initiate the swap process.
   * - If 3D Secure (3DS) authentication is required, handle this through the 'authorizePayment' mutation to obtain necessary details for completing 3DS verification (optional, as confirmSwap does this before creation of reservation - however at confirmSwap this will end-up in exception thrown if payment was not paid.)
   * - If there is a need to change the PaymentMethod, consider using the 'changePaymentMethod' mutation. It is recommended to avoid this step when possible, as integrating this into the current front-end flow can be complex.
   * - Finally, complete the swap process using the 'completeSwap' mutation.
   *
   * Swap Handling:
   * - The swap process can be managed either synchronously or asynchronously:
   *   - Synchronous handling involves performing the 'authorizePayment' mutation to directly manage 3DS verification and immediately resolve any issues such as insufficient funds.
   *   - Asynchronous handling allows the back-end to manage the swap process, including 3DS verification and payment settlements, without immediate front-end intervention. This method concludes with the automatic confirmation of the swap once the payment is settled.
   *
   * Recommendation:
   * - The synchronous approach is generally safer in terms of data flow integrity and transparency, providing immediate feedback on transaction status, such as payment method issues or the need for 3DS verification.
   *
   * Read more:
   * - https://github.com/Stepapp/Backend/blob/main/docs/Domain/entities/%F0%9F%94%84%20Swap.md
   * - https://github.com/Stepapp/Backend/blob/main/docs/Domain/operations/%E2%8F%A9%20Define%20Swap.md
   *
   */
  declareSwap: SwapDeclared;
  deleteProfile: Scalars["Boolean"]["output"];
  deleteProperty: Scalars["Boolean"]["output"];
  deleteWorkerDayOff: Scalars["Boolean"]["output"];
  detachDeviceFromUser: Scalars["Boolean"]["output"];
  /** Mutation responsible for handling "draft" checkout state, where one is not ordered. This mutation will automatically handle creation of new checkout or update of existing one, along with transferring ownership through unique fingerprint (provide it in X-Device-Fingerprint header) and authorization header. */
  draftCheckout: Checkout;
  finalizeConfirmation: Cancellation;
  pay: Payment;
  /**
   * ## payReservation
   *
   * Processes the payment for a reservation in AWAITING_PAYMENT or ACCEPTED state. This mutation separates the acceptance
   * and payment steps to handle errors more effectively. Use "acceptReservation" followed by "payReservation" for a
   * sequential flow, or "acceptAndPayReservation" for a combined operation, though the latter is less recommended.
   *
   */
  payReservation: ReservationVm;
  /** Mark all messages in channel as read. [V24.02.04] */
  readChannel: ChatChannel;
  refreshToken: Scalars["String"]["output"];
  registerAccountWithFacebook: Scalars["String"]["output"];
  registerAccountWithGoogle: Scalars["String"]["output"];
  registerAccountWithPhoneNumber: Scalars["String"]["output"];
  /**
   * Reject completion of order submitted by a worker.
   * @deprecated Rejecting work submission was deprecated in favor of communicating problems with customer support software like Intercom - from this time mutation will be noop and will return the same order as input. Mutation itself will be removed in near future.
   */
  rejectWorkSubmission: Reservation;
  /** Remove provided payment method from Stripe Account */
  removePaymentMethod: Scalars["Boolean"]["output"];
  removeWorkerBankAccount: Scalars["Boolean"]["output"];
  removeWorkerFromLocalization: Scalars["Boolean"]["output"];
  /**
   * Reservations are immutable entity in system, once they are created we cannot modify their contents to prevent inconsistency and fraud, however we can replace them with new ones. This mutation will create a new checkout with new reservation and return it to user, such a checkout is not connected to any other checkout in system. Once checkout will be realized, reservation connected to it will be cancelled and replaced with newer one, additionally some cases will result in additional fee charge from attached payment method.
   * @deprecated This method has been deprecated and replaced by the 'defineSwap' mutation. The 'defineSwap' mutation accepts a checkoutId and generates a new entity called 'Swap,' which encapsulates both the original and new reservations along with any necessary payment adjustments required to complete the reservation replacement. This new method streamlines the process, ensuring a more efficient and transparent transaction handling.
   */
  replacementReservation: Reservation;
  resolveIssue: Issue;
  /** Operation will execute 'updatePayment' to change paymentMethodId of your payment of choice, and then 'capturePayment' in order to attempt charge again. */
  retryPayment: Payment;
  sendMessage: ChatMessage;
  /**
   * Initiate the setup of a payment method for 'off-session' use, effective for subscriptions and future payments. This operation is necessary to facilitate seamless transactions by pre-authorising a payment method. Here's the basic sequence:
   *     1. **Collect and Submit Card Details**: Utilize Stripe.js or Stripe's mobile SDKs on your front-end to gather card details securely. Upon submission, Stripe returns a PaymentMethod ID.
   *     2. **Store PaymentMethod (createPaymentMethod)**: Forward payment method to be stored and associated with user.
   *     3. **Create Setup Intent (setupPaymentMethodForFutureUsage)**: Create a SetupIntent using Stripe API with the received PaymentMethod ID, which pre-authorsizes the payment method for future use.
   *     4. **Confirmation of SetupIntent**: Depending on the requirements of the card, you may need to confirm the SetupIntent on your frontend (you can do that using Stripe.js and provided clientSecret). Compliance with 3D Secure Verification may be required for some cards.
   */
  setupPaymentMethodForFutureUsage: PaymentMethodNeedsSetup;
  /** Solve authentication challenge by providing previously generated one-time access code. */
  solveLoginChallenge: AuthenticationDataModel;
  startLoginChallenge: Scalars["Boolean"]["output"];
  /** Mutation dedicated for starting work on order. */
  startOrder: ReservationVm;
  /** Mutation dedicated for handling any discount existing in software system, in case of coupon it will be adding coupon to user's wallet, vouchers will be added to user’s a virtual wallet, and share-code will be handled same as coupon is. */
  storeDiscount: DiscountReceipt;
  /** Mutation dedicated for completing work on order. */
  submitOrderCompletion: ReservationVm;
  submitWorkerPayoutPayout: Scalars["Boolean"]["output"];
  updateBillingAddress: BillingAddress;
  updateCustomerProfile: Scalars["Boolean"]["output"];
  /** Update payment is generic action dedicated for client-side applications. It allow to perform adjustments how payments is processed. */
  updatePayment: Payment;
  updateProfileImage: Scalars["Boolean"]["output"];
  updateProperty: Scalars["Boolean"]["output"];
  /** Update notes assigned to reservation address. */
  updateReservationCustomerNote: ReservationVm;
  /** Update notes assigned to reservation. */
  updateReservationNote: ReservationVm;
  updateWorkerCalendar: Scalars["Boolean"]["output"];
  updateWorkerProfile: Scalars["Boolean"]["output"];
  uploadDocumentForVerification: Scalars["Boolean"]["output"];
  /** GraphQL Playground do not support uploading of files, it is recommended to use Alair instead: https://stackoverflow.com/questions/53445012/graphiql-upload-file. */
  uploadFile: File;
  /** Take input as base64, prepare and upload it to AWS S3. */
  uploadFileByBase64: File;
  v2CancelSubscription: Scalars["Boolean"]["output"];
  v2DraftCheckout: V2Checkout;
  validateAddressInLocalization: Scalars["Boolean"]["output"];
  /** @deprecated Use solveLoginChallenge instead */
  verifyAccount: AuthenticationDataModel;
};

export type MutationAcceptReservationArgs = {
  reservationId: Scalars["String"]["input"];
};

export type MutationAcceptWorkSubmissionArgs = {
  orderId: Scalars["String"]["input"];
};

export type MutationAddWorkerBankAccountArgs = {
  data: AddBankAccountInput;
};

export type MutationApplyForJobArgs = {
  jobId: Scalars["String"]["input"];
};

export type MutationAssignWorkerToLocalizationArgs = {
  payload: AssignWorkerToLocalizationsDto;
};

export type MutationAttachDeviceToUserArgs = {
  data: PushNotificationDeviceInput;
};

export type MutationAuthenticateWithFacebookArgs = {
  data: AuthenticateWithSocialMediaInput;
};

export type MutationAuthenticateWithGoogleArgs = {
  data: AuthenticateWithSocialMediaInput;
};

export type MutationAuthorizePaymentArgs = {
  paymentId: Scalars["String"]["input"];
};

export type MutationCancelReservationArgs = {
  reason: Scalars["String"]["input"];
  reservationId: Scalars["String"]["input"];
};

export type MutationCancelSubscriptionArgs = {
  subscriptionId: Scalars["String"]["input"];
};

export type MutationChangePaymentMethodArgs = {
  paymentId: Scalars["String"]["input"];
  paymentMethodId: Scalars["String"]["input"];
  reservationId: Scalars["String"]["input"];
};

export type MutationCheckoutPaymentVerificationArgs = {
  input: VerifyCheckoutPaymentMethodInput;
};

export type MutationCompleteAdditionalEditArgs = {
  swapId: Scalars["String"]["input"];
};

export type MutationCompleteAttributeEditArgs = {
  swapId: Scalars["String"]["input"];
};

export type MutationCompleteAuthorizationArgs = {
  paymentId: Scalars["String"]["input"];
};

export type MutationCompleteRescheduleArgs = {
  swapId: Scalars["String"]["input"];
};

export type MutationCompleteSwapArgs = {
  swapId: Scalars["String"]["input"];
};

export type MutationConfirmCheckoutArgs = {
  checkoutId: Scalars["String"]["input"];
};

export type MutationConfirmPaymentArgs = {
  paymentId: Scalars["String"]["input"];
};

export type MutationConfirmPaymentMethodSetupArgs = {
  returnUrl: Scalars["String"]["input"];
  setupIntentId: Scalars["String"]["input"];
};

export type MutationCreateCancellationArgs = {
  reservationId: Scalars["String"]["input"];
};

export type MutationCreateCustomerProfileArgs = {
  data: CreateCustomerProfileInput;
};

export type MutationCreatePaymentMethodArgs = {
  paymentMethodToken: Scalars["String"]["input"];
};

export type MutationCreatePropertyArgs = {
  data: CreatePropertyInput;
};

export type MutationCreateReviewArgs = {
  review: ReviewPayload;
};

export type MutationCreateWorkerDayOffArgs = {
  data: CreateWorkerDayOffInput;
};

export type MutationCreateWorkerProfileArgs = {
  data: CreateWorkerProfileInput;
};

export type MutationDeclareRescheduleReservationArgs = {
  data: EstimateReservationRescheduleInput;
  reservationId: Scalars["String"]["input"];
};

export type MutationDeclareReservationAdditionalEditArgs = {
  data: EstimateReservationAdditionalServiceEditInput;
  reservationId: Scalars["String"]["input"];
};

export type MutationDeclareReservationAttributeEditArgs = {
  data: EstimateReservationAttributeEditInput;
  reservationId: Scalars["String"]["input"];
};

export type MutationDeclareSwapArgs = {
  checkoutId: Scalars["String"]["input"];
};

export type MutationDeletePropertyArgs = {
  data: DeletePropertyInput;
};

export type MutationDeleteWorkerDayOffArgs = {
  data: DeleteWorkerDayOffInput;
};

export type MutationDetachDeviceFromUserArgs = {
  data: DetachPushNotificationDeviceInput;
};

export type MutationDraftCheckoutArgs = {
  checkoutPayload: CheckoutPayload;
  skipValidation?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationFinalizeConfirmationArgs = {
  whereUnique: Scalars["String"]["input"];
};

export type MutationPayArgs = {
  paymentId: Scalars["String"]["input"];
};

export type MutationPayReservationArgs = {
  reservationId: Scalars["String"]["input"];
};

export type MutationReadChannelArgs = {
  channelId: Scalars["String"]["input"];
};

export type MutationRefreshTokenArgs = {
  refresh_token: Scalars["String"]["input"];
};

export type MutationRegisterAccountWithFacebookArgs = {
  data: RegisterAccountWithFacebookInput;
};

export type MutationRegisterAccountWithGoogleArgs = {
  data: RegisterAccountWithGoogleInput;
};

export type MutationRegisterAccountWithPhoneNumberArgs = {
  data: RegisterAccountWithPhoneNumberInput;
};

export type MutationRejectWorkSubmissionArgs = {
  orderId: Scalars["String"]["input"];
};

export type MutationRemovePaymentMethodArgs = {
  paymentMethodId: Scalars["String"]["input"];
};

export type MutationRemoveWorkerFromLocalizationArgs = {
  payload: RemoveWorkerFromLocalizationDto;
};

export type MutationReplacementReservationArgs = {
  replacementCheckoutId: Scalars["String"]["input"];
};

export type MutationResolveIssueArgs = {
  actionId: Scalars["String"]["input"];
  issueId: Scalars["String"]["input"];
};

export type MutationRetryPaymentArgs = {
  paymentId?: InputMaybe<Scalars["String"]["input"]>;
  reservationId: Scalars["String"]["input"];
  stripePaymentMethodId: Scalars["String"]["input"];
};

export type MutationSendMessageArgs = {
  message: ChatMessageInput;
};

export type MutationSetupPaymentMethodForFutureUsageArgs = {
  paymentMethodId: Scalars["String"]["input"];
};

export type MutationSolveLoginChallengeArgs = {
  data: SolveAuthorizationChallengeInput;
};

export type MutationStartLoginChallengeArgs = {
  data: DefineAuthorizationChallengeInput;
};

export type MutationStartOrderArgs = {
  orderId: Scalars["String"]["input"];
};

export type MutationStoreDiscountArgs = {
  code: Scalars["String"]["input"];
};

export type MutationSubmitOrderCompletionArgs = {
  file: Scalars["String"]["input"];
  orderId: Scalars["String"]["input"];
};

export type MutationSubmitWorkerPayoutPayoutArgs = {
  data: SubmitPayoutInput;
};

export type MutationUpdateBillingAddressArgs = {
  data: AddressAbstractPayload;
};

export type MutationUpdateCustomerProfileArgs = {
  data: UpdateCustomerProfileInput;
};

export type MutationUpdatePaymentArgs = {
  data: PaymentUpdateInput;
  paymentId: Scalars["String"]["input"];
  reservationId: Scalars["String"]["input"];
};

export type MutationUpdateProfileImageArgs = {
  data: UpdateProfileImageInput;
};

export type MutationUpdatePropertyArgs = {
  data: UpdatePropertyInput;
};

export type MutationUpdateReservationCustomerNoteArgs = {
  note: Scalars["String"]["input"];
  reservationId: Scalars["String"]["input"];
};

export type MutationUpdateReservationNoteArgs = {
  note: Scalars["String"]["input"];
  reservationId: Scalars["String"]["input"];
};

export type MutationUpdateWorkerCalendarArgs = {
  data: UpdateWorkerCalendarInput;
};

export type MutationUpdateWorkerProfileArgs = {
  data: UpdateWorkerProfileInput;
};

export type MutationUploadDocumentForVerificationArgs = {
  data: UploadDocumentForVerificationInput;
};

export type MutationUploadFileArgs = {
  file: Scalars["Upload"]["input"];
};

export type MutationUploadFileByBase64Args = {
  base64: Scalars["String"]["input"];
};

export type MutationV2CancelSubscriptionArgs = {
  reason: Scalars["String"]["input"];
  subscriptionId: Scalars["String"]["input"];
};

export type MutationV2DraftCheckoutArgs = {
  data: V2DraftCheckoutInput;
};

export type MutationValidateAddressInLocalizationArgs = {
  payload: ValidateAddressInLocalizationInput;
};

export type MutationVerifyAccountArgs = {
  data: VerifyAccountPhoneNumberInput;
};

export type NotFulfilledSwap = Swap & {
  fromReservation: ReservationVm;
  id: Scalars["ID"]["output"];
  /** Payment is not required as reservation changes may be free of charge under specific circumstances. */
  payment?: Maybe<Payment>;
  /** Field represents newly created reservation, this field is considered nullable because if the payment exists it must be completed before reservation will be created. */
  toReservation?: Maybe<ReservationVm>;
};

/** numeric type, ie. input or counter */
export enum NumericType {
  Counter = "COUNTER",
  Input = "INPUT",
}

export enum Order_Discount_Type {
  Coupon = "COUPON",
  Referral = "REFERRAL",
  Subscription = "SUBSCRIPTION",
  VirtualWallet = "VIRTUAL_WALLET",
}

export enum OnboardingStatusEnum {
  Created = "CREATED",
  Pending = "PENDING",
  Verified = "VERIFIED",
}

export type OrderAttribute = {
  attribute: Attribute;
  currency: Scalars["String"]["output"];
  /** Discounts applied for this specific attribute, field use to show conditional discount from subscription. */
  discount?: Maybe<Array<Maybe<OrderDiscount>>>;
  price: Scalars["Int"]["output"];
  quantity?: Maybe<Scalars["Float"]["output"]>;
  timeConsumption?: Maybe<Scalars["String"]["output"]>;
  values: Array<Maybe<AttributeValue>>;
};

export type OrderAttributePayload = {
  /** Specify an ID of chosen attribute. This is only applicable for attributes with type SINGLE_CHOICE, NUMERIC or MULTIPLE_CHOICE. */
  attributeId: Scalars["String"]["input"];
  /** Allows to specify the quantity of the answer. For example, if the question is 'How many people will be attending?' the answer could be '2'. This is only applicable for attributes with type NUMERIC */
  quantity?: InputMaybe<Scalars["Float"]["input"]>;
  /** Specify an IDs of chosen values. This is only applicable for attributes with type SINGLE_CHOICE, NUMERIC or MULTIPLE_CHOICE. When attribute type is MULTIPLE_CHOICE then only more than one value can be selected.. When attribute type is NUMERIC or SINGLE_CHOICE then only one value can be selected. */
  valueId: Array<Scalars["String"]["input"]>;
};

export type OrderDiscount = {
  fixedValue: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  type: OrderDiscountType;
};

export enum OrderDiscountType {
  Coupon = "COUPON",
  Referral = "REFERRAL",
  Subscription = "SUBSCRIPTION",
  VirtualWallet = "VIRTUAL_WALLET",
}

/** Order House Area is a model responsible for price calculated in checkout which include price relative to area of property. */
export type OrderHouseArea = {
  /** Discounts applied for this specific attribute, field use to show conditional discount from subscription. */
  discount?: Maybe<Array<Maybe<OrderDiscount>>>;
  houseAreaAttributeId: Scalars["String"]["output"];
  houseAreaStepId: Scalars["String"]["output"];
  price: Scalars["Money"]["output"];
  timeConsumption: Scalars["String"]["output"];
};

/** OrderPeriodicity is a snapshot information about SubscriptionOption that was chosen to specific reservation. */
export type OrderPeriodicity = {
  /** Cycle duration defines time of delay between creating additional subscription from past one, in case where value 0 subscription will be not created and system will create single-time reservation instead. */
  cycleDuration: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  discount: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

/** Order processing fee happens in various cases in our application, this can be modification of reservation after specific time or cancellation of offer. This fee is not refundable. */
export type OrderProcessingFee = {
  amount: Scalars["Int"]["output"];
  currency: Scalars["String"]["output"];
  type: ProcessingFeeType;
};

export type OrderService = {
  currency: Scalars["String"]["output"];
  /** Discounts applied for this specific attribute, field use to show conditional discount from subscription. */
  discount?: Maybe<Array<Maybe<OrderDiscount>>>;
  price: Scalars["Int"]["output"];
  service: Service;
  /** Time consumption is a filed represented by ISO-8601 duration string. Commonly it indicates how much time it take to perform a specific task. */
  timeConsumption: Scalars["String"]["output"];
  variants: Array<OrderServiceVariants>;
};

export type OrderServicePayload = {
  serviceId: Scalars["String"]["input"];
  variants: Array<OrderServiceVariantsInput>;
};

export type OrderServiceVariants = {
  currency: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  isFree?: Maybe<Scalars["Boolean"]["output"]>;
  /** Represents the price of the individual unit. */
  price: Scalars["Int"]["output"];
  quantity: Scalars["Float"]["output"];
  /** Represents combined price of all units of this variant. */
  sumPrice: Scalars["Money"]["output"];
  /** Time consumption is a filed represented by ISO-8601 duration string. Commonly it indicates how much time it take to perform specific task. Summarized Value for given variant. */
  sumTimeConsumption: Scalars["String"]["output"];
  /** Time consumption is a filed represented by ISO-8601 duration string. Commonly it indicates how much time it take to perform specific task. */
  timeConsumption: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  variantId: Scalars["String"]["output"];
};

export type OrderServiceVariantsInput = {
  quantity: Scalars["Float"]["input"];
  variantId: Scalars["String"]["input"];
};

export enum Processing_Fee_Type {
  LastMinuteFee = "LAST_MINUTE_FEE",
  ModificationFee = "MODIFICATION_FEE",
  SubscriptionCancelFeeTotal = "SUBSCRIPTION_CANCEL_FEE_TOTAL",
}

export type PageInfo = {
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars["ConnectionCursor"]["output"]>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars["ConnectionCursor"]["output"]>;
};

/** Payment represents a single payment that exists in the system, they can be in various states like PENDING, REQUIRES_ACTION, SUCCEEDED, FAILED, etc. every action taken on the individual payment will be recorded and published to related records - ex. finishing a payment related to reservation will trigger a reservation paid event. */
export type Payment = {
  amount: Scalars["Int"]["output"];
  appliedDiscount: Scalars["Int"]["output"];
  completionDate?: Maybe<Scalars["DateTime"]["output"]>;
  currency: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  paymentMethodId?: Maybe<Scalars["String"]["output"]>;
  paymentUpdateDate?: Maybe<Scalars["DateTime"]["output"]>;
  status: PaymentStatus;
  /** When status is `REQUIRES_ACTION` this field will contain necessary information to complete additional checks associated with payment method. These checks can be completed by using exposed mutations like `authorizePayment` and `completePayment`. */
  stripePaymentNextStep?: Maybe<PaymentAdditionalAction>;
};

/** Type of 3D Secure action */
export enum PaymentActionType {
  RedirectUrl = "REDIRECT_URL",
  UseStripeSdk = "USE_STRIPE_SDK",
}

/** Payment's next action can be handled in different ways and we cannot actually choose a preferred way to handle them. This union type represents all possible ways to handle the next action. */
export type PaymentAdditionalAction = PaymentRedirectStep | PaymentStripeSdkStep;

export type PaymentMethodNeedsSetup = {
  clientSecret: Scalars["String"]["output"];
  confirmed: Scalars["Boolean"]["output"];
  paymentMethodId: Scalars["String"]["output"];
  requiresAction: Scalars["Boolean"]["output"];
  setupIntentId: Scalars["String"]["output"];
};

export type PaymentMethodSetupCompleted = {
  clientSecret: Scalars["String"]["output"];
  confirmed: Scalars["Boolean"]["output"];
  paymentMethodId: Scalars["String"]["output"];
  requiresAction: Scalars["Boolean"]["output"];
  setupIntentId: Scalars["String"]["output"];
};

/** payment methods for customer  */
export type PaymentMethodsModel = {
  brand: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  last4: Scalars["String"]["output"];
};

export type PaymentRedirectStep = {
  /** This is a client secret which will be used to confirm payment, it is a secret key which should be kept in secret and not shared with anyone. Use stripe.confirmCardPayment method to confirm payment. */
  clientSecret: Scalars["String"]["output"];
  paymentIntentId: Scalars["String"]["output"];
  redirectUrl: Scalars["String"]["output"];
  type: PaymentActionType;
};

/** Statuses of payments are confusing according to how this is handled by other payment providers and will have major change in near time, see: https://github.com/Stepapp/Backend/issues/1362 */
export enum PaymentStatus {
  /** Payment was cancelled by the user or the system, it cannot be modified and used anymore. */
  Canceled = "CANCELED",
  /** Payment could not be processed and failed. This can happen if the payment provider rejects the payment or if the payment provider is not available. In this case the payment can be retried or the payment method can be changed. If the payment is retried and fails again, the payment will be marked as failed and can  be retried again. */
  Failed = "FAILED",
  /** Payment was successfully paid and is now completed. */
  Paid = "PAID",
  /** Newly created payment, it is not yet processed and can be modified or cancelled. */
  Pending = "PENDING",
  /** Payment is currently processing which means it is waiting for the payment provider to process the payment and is locked on our side until the payment is either paid or failed */
  Processing = "PROCESSING",
  /** If the payment requires additional actions, such as authentication with 3D Secure , the StripePaymentIntent has a status of requires_action. If payment don't require additional actions, the StripePaymentIntent has a status of requires_capture (depending on configuration), the most straightforward transition from this status is processing. */
  RequiresAction = "REQUIRES_ACTION",
  /** Payment is ready to be charged. */
  RequiresCapture = "REQUIRES_CAPTURE",
}

export type PaymentStripeSdkStep = {
  /** This is a client secret which will be used to confirm payment, it is a secret key which should be kept in secret and not shared with anyone. Use stripe.confirmCardPayment method to confirm payment. */
  clientSecret: Scalars["String"]["output"];
  paymentIntentId: Scalars["String"]["output"];
  /** This field contain serialized information about stripe_sdk which we get from Stripe Invoices, it's a bit more complex than using a simple redirect URL but there is not other option available. For further questions refer to Stripe documentation at  */
  stripeSdkData: Scalars["String"]["output"];
  type: PaymentActionType;
};

export type PaymentUpdateInput = {
  /** PaymentMethod unique identifier from Stripe or 'cash' */
  paymentMethodId?: InputMaybe<Scalars["String"]["input"]>;
};

/** PaymentsMetadataModel */
export type PaymentsMetadataModel = {
  stripeCustomerId?: Maybe<Scalars["String"]["output"]>;
};

export type Payout = {
  address?: Maybe<Scalars["String"]["output"]>;
  amount: Scalars["Int"]["output"];
  bankName?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  customerName?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  profileId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  type: PayoutsHistoryType;
};

/** Payout history record type */
export enum PayoutsHistoryType {
  Payout = "PAYOUT",
  Transaction = "TRANSACTION",
}

/** PayoutsMetadataModel */
export type PayoutsMetadataModel = {
  balance?: Maybe<Scalars["Int"]["output"]>;
  bankAccountId?: Maybe<Scalars["String"]["output"]>;
  bankAccountName?: Maybe<Scalars["String"]["output"]>;
  connectedAccountId?: Maybe<Scalars["String"]["output"]>;
  extraInformation?: Maybe<Array<Scalars["String"]["output"]>>;
  onboardingStatus?: Maybe<OnboardingStatusEnum>;
};

/** Type of processing fee */
export enum ProcessingFeeType {
  /**
   * When order is modified less than 24h before start, there is a fee of 100% of the order value.
   * @deprecated In subject to change, not estabilished yet
   */
  LastMinuteFee = "LAST_MINUTE_FEE",
  /**
   * When order is modified in a reasonable timeframe where Stepapp can react to it, there is nominal fixed-price fee.
   * @deprecated In subject to change, not estabilished yet
   */
  ModificationFee = "MODIFICATION_FEE",
  /** Total sum of fees from all reservations to be cancel in subscription */
  SubscriptionCancelFeeTotal = "SUBSCRIPTION_CANCEL_FEE_TOTAL",
}

export type Profile = {
  description?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  experience?: Maybe<Scalars["String"]["output"]>;
  firstName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  /** Represents a URL to profile file. */
  image?: Maybe<Scalars["String"]["output"]>;
  lastName: Scalars["String"]["output"];
  phone: Scalars["String"]["output"];
};

/** profile information */
export type ProfileInformation = {
  customerMetadata?: Maybe<CustomerMetadata>;
  dateOfBirth?: Maybe<Scalars["DateTime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  image?: Maybe<Scalars["String"]["output"]>;
  jobOffersEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  lastName: Scalars["String"]["output"];
  newsletterNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  payoutsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  phone: Scalars["String"]["output"];
  profileType: ProfileTypeEnum;
  pushNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  smsNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  workerMetadata?: Maybe<WorkerMetadata>;
};

/** profile  */
export type ProfileModel = {
  color?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["String"]["output"];
  lastLoginDate?: Maybe<Scalars["DateTime"]["output"]>;
  profileInformation: ProfileInformation;
  registerType: RegisterTypeEnum;
  tagId?: Maybe<Scalars["String"]["output"]>;
};

export enum ProfileTypeEnum {
  Admin = "ADMIN",
  Customer = "CUSTOMER",
  Worker = "WORKER",
}

export type PushNotificationDeviceInput = {
  /** Expo device token */
  deviceToken: Scalars["String"]["input"];
  deviceType: PushNotificationDeviceTypeEnum;
};

/** Device Type For Push Notification */
export enum PushNotificationDeviceTypeEnum {
  Android = "ANDROID",
  Ios = "IOS",
}

export type Query = {
  /** List all payments accessible by currently authenticated user. */
  allPayments: Array<Payment>;
  billingAddress?: Maybe<BillingAddress>;
  cancellation: Cancellation;
  checkIfProfileExists: Scalars["Boolean"]["output"];
  /** Get estimation of fees that will be charged from attached payment method for modification or cancellation of reservation. */
  estimateProcessingFee?: Maybe<OrderProcessingFee>;
  /** Estimates cost of reservation reschedule  */
  estimateReservationAdditionalServiceEdit?: Maybe<EstimateReservationAdditionalServiceEditResponse>;
  /** Estimates cost of reservation question answers edit  */
  estimateReservationAttributeEdit?: Maybe<EstimateReservationAttributeEditResponse>;
  /** Reservations are immutable entity in system, once they are created we cannot modify their contents to prevent inconsistency and fraud, however we can replace them with new ones. This mutation will create a new checkout with new reservation and return it to user, such a checkout is not connected to any other checkout in system. Once checkout will be realized, reservation connected to it will be cancelled and replaced with newer one, additionally some cases will result in additional fee charge from attached payment method. */
  estimateReservationReplacement: Checkout;
  /** Estimates cost of reservation reschedule  */
  estimateReservationReschedule?: Maybe<OrderProcessingFee>;
  /** Get estimation of fees that will be charged from attached payment method for cancellation of subscription. */
  estimateSubscriptionProcessingFee?: Maybe<SubscriptionProcessingFee>;
  generateAutocompleteForAddress: Array<AutoCompleteResponseModel>;
  generateAvailabilityCalendarForReservation: Array<AvailabilityCalendarModel>;
  getAverageReviewsForApplication: ReviewAverageResult;
  getAverageReviewsForBundle: ReviewAverageResult;
  getAverageReviewsForWorker: ReviewAverageResult;
  /** Find a specific Bundle (also known as "Standalone Service") */
  getBundle: Bundle;
  /** Find a specific Bundle (also known as "Standalone Service") */
  getBundleBySlug: Bundle;
  /** Returns the cancellation fee related to given reservation or returns null if no fee is applicable. */
  getCancellationFee?: Maybe<CancellationFee>;
  getChatChannelById: ChatChannel;
  getChatChannelByOrderId: ChatChannel;
  getCheckout: Checkout;
  getCurrentAppVersion: AppVersion;
  getHomepageBannerByLocalizationId: HomepageBanner;
  getIssue: Issue;
  /** Query dedicated to find specific job offer by an id. */
  getJobOfferById: JobOffer;
  getLocalizationByCoordinates: LocalizationModelItems;
  getMyProfile: ProfileModel;
  /** Get information about single payment that belongs to the current user. */
  getPayment: Payment;
  /** Query dedicated for getting reservation by id for a customer or worker. */
  getReservationById: ReservationVm;
  getUnresolvedIssues: Array<Issue>;
  /** Provides information about Customer's virtual wallet. */
  getVirtualWalletBalance: UserBalance;
  getWorkerTimeStats: WorkerTimeStatsModel;
  /** Find all bundles (also known as "Standalone Service") in a given localization. This will show only accessible bundles. */
  listBundles: Array<Bundle>;
  listCategories: Array<CategoryCustomerModel>;
  listCategoryCarousel: Array<V2CategoryCarousel>;
  /** List chat channels that can be accessed by the current user. */
  listChatChannels: Array<ChatChannel>;
  /** List chat channels that can be accessed by the current user. */
  listChatChannelsForReservations: Array<ChatChannel>;
  listCountries: Array<Country>;
  /** Find all bundles that should be displayed at home page. */
  listFeaturedBundles: Array<Bundle>;
  listHomepageBanners: Array<HomepageBanner>;
  /** Query dedicated to find all available job offers for a worker in specific location. When worker wants to take a job, he should use applyForJob mutation. */
  listJobOffers: Array<JobOffer>;
  listLocalizationWithPagination: LocalizationPaginationModel;
  listOwnedCoupons: Array<StoredDiscount>;
  listPaymentMethods: Array<PaymentMethodsModel>;
  /** Get information about payments that belongs to the current user. (allPayments is future alternative that will receive updates) */
  listPaymentsHistory: Array<Payment>;
  /** Get information about payouts for current user. */
  listPayoutsHistory: Array<Payout>;
  /** Query dedicated for listing all reservations for customer or worker. */
  listReservations: Array<ReservationVm>;
  listReviewsForHomepage: Array<Review>;
  /** Returns the referral code of the current user */
  myReferral: Referral;
  review: Review;
  reviewAggregate: Array<ReviewAggregateResponse>;
  reviews: ReviewConnection;
  /** Find a single Swap by ID */
  swap: Swap;
  v1ListPaginatedJobOffersForAdmin: V1JobOffersPaginatedViewModel;
  v2GetBundleAdditionalById: V2BundleAdditional;
  v2GetBundleAdditionalVariantById: V2BundleAdditionalVariant;
  v2GetBundleById: V2Bundle;
  v2GetBundleBySlug: V2Bundle;
  v2GetBundleHouseAreaById: V2BundleHouseAreaModel;
  v2GetBundleQuestionCategoryById: V2BundleQuestionCategory;
  v2GetBundleSubscriptionOptionById: V2BundleSubscriptionOption;
  v2GetCategoryById: CategoryCustomerModel;
  v2GetCheckout: V2Checkout;
  v2GetMyAssignedBonuses: Array<V2Bonus>;
  v2GetMyEnabledBonuses: Array<V2Bonus>;
  v2ListBundles: Array<V2Bundle>;
};

export type QueryCancellationArgs = {
  cancellationId: Scalars["String"]["input"];
};

export type QueryEstimateProcessingFeeArgs = {
  reservationId: Scalars["String"]["input"];
};

export type QueryEstimateReservationAdditionalServiceEditArgs = {
  data: EstimateReservationAdditionalServiceEditInput;
  reservationId: Scalars["String"]["input"];
};

export type QueryEstimateReservationAttributeEditArgs = {
  data: EstimateReservationAttributeEditInput;
  reservationId: Scalars["String"]["input"];
};

export type QueryEstimateReservationReplacementArgs = {
  replacementCheckoutPayload: ReplacementCheckoutInput;
  reservationId: Scalars["String"]["input"];
};

export type QueryEstimateReservationRescheduleArgs = {
  data: EstimateReservationRescheduleInput;
  reservationId: Scalars["String"]["input"];
};

export type QueryEstimateSubscriptionProcessingFeeArgs = {
  subscriptionId: Scalars["String"]["input"];
};

export type QueryGenerateAutocompleteForAddressArgs = {
  payload: GenerateAutocompleteForAddressInput;
};

export type QueryGenerateAvailabilityCalendarForReservationArgs = {
  data: GetAvailabilityCalendarForReservationInput;
};

export type QueryGetAverageReviewsForBundleArgs = {
  bundleId: Scalars["String"]["input"];
};

export type QueryGetAverageReviewsForWorkerArgs = {
  workerId: Scalars["String"]["input"];
};

export type QueryGetBundleArgs = {
  bundleId: Scalars["String"]["input"];
};

export type QueryGetBundleBySlugArgs = {
  localizationId: Scalars["String"]["input"];
  slug: Scalars["String"]["input"];
};

export type QueryGetCancellationFeeArgs = {
  reservationId: Scalars["String"]["input"];
};

export type QueryGetChatChannelByIdArgs = {
  channelId: Scalars["String"]["input"];
};

export type QueryGetChatChannelByOrderIdArgs = {
  orderId: Scalars["String"]["input"];
};

export type QueryGetCurrentAppVersionArgs = {
  appType: AppTypeEnum;
};

export type QueryGetHomepageBannerByLocalizationIdArgs = {
  data: GetHomepageBannerByLocalizationIdInput;
};

export type QueryGetIssueArgs = {
  issueId: Scalars["String"]["input"];
};

export type QueryGetJobOfferByIdArgs = {
  jobId: Scalars["String"]["input"];
};

export type QueryGetLocalizationByCoordinatesArgs = {
  latitude: Scalars["Float"]["input"];
  longitude: Scalars["Float"]["input"];
};

export type QueryGetPaymentArgs = {
  paymentId: Scalars["String"]["input"];
};

export type QueryGetReservationByIdArgs = {
  orderId: Scalars["String"]["input"];
};

export type QueryGetWorkerTimeStatsArgs = {
  endDate: Scalars["DateTime"]["input"];
  startDate: Scalars["DateTime"]["input"];
};

export type QueryListBundlesArgs = {
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  localizationId: Scalars["String"]["input"];
};

export type QueryListCategoriesArgs = {
  localizationId: Scalars["String"]["input"];
};

export type QueryListCategoryCarouselArgs = {
  categoryId: Scalars["String"]["input"];
};

export type QueryListChatChannelsForReservationsArgs = {
  payload: ListChatChannelsForReservationsInput;
};

export type QueryListFeaturedBundlesArgs = {
  localization: Scalars["String"]["input"];
};

export type QueryListJobOffersArgs = {
  locationId: Scalars["String"]["input"];
};

export type QueryListLocalizationWithPaginationArgs = {
  limit?: Scalars["Int"]["input"];
  page?: Scalars["Int"]["input"];
};

export type QueryListReservationsArgs = {
  filter?: InputMaybe<ReservationFilter>;
};

export type QueryReviewArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryReviewAggregateArgs = {
  filter?: InputMaybe<ReviewAggregateFilter>;
};

export type QueryReviewsArgs = {
  filter?: ReviewFilter;
  paging?: CursorPaging;
  sorting?: Array<ReviewSort>;
};

export type QuerySwapArgs = {
  id: Scalars["String"]["input"];
};

export type QueryV1ListPaginatedJobOffersForAdminArgs = {
  limit?: Scalars["Int"]["input"];
  localizationId: Scalars["String"]["input"];
  page?: Scalars["Int"]["input"];
};

export type QueryV2GetBundleAdditionalByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryV2GetBundleAdditionalVariantByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryV2GetBundleByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryV2GetBundleBySlugArgs = {
  localizationId: Scalars["String"]["input"];
  slug: Scalars["String"]["input"];
};

export type QueryV2GetBundleHouseAreaByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryV2GetBundleQuestionCategoryByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryV2GetBundleSubscriptionOptionByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryV2GetCategoryByIdArgs = {
  id: Scalars["String"]["input"];
};

export type QueryV2ListBundlesArgs = {
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  localizationId: Scalars["String"]["input"];
};

export type QuestionAnswersInReservationEditInput = {
  attributeId: Scalars["ID"]["input"];
  quantity?: Scalars["Int"]["input"];
  valueIds: Array<Scalars["ID"]["input"]>;
};

export type Referral = {
  code: Scalars["String"]["output"];
  /** Represents the value which provider will receive as a reward. */
  providerReward: Scalars["Int"]["output"];
  /** Represents the value which referee will receive as a reward. */
  value: Scalars["Int"]["output"];
};

export type RegisterAccountWithFacebookInput = {
  facebook_token?: InputMaybe<Scalars["String"]["input"]>;
  phone_number: Scalars["String"]["input"];
};

export type RegisterAccountWithGoogleInput = {
  google_token?: InputMaybe<Scalars["String"]["input"]>;
  phone_number: Scalars["String"]["input"];
};

export type RegisterAccountWithPhoneNumberInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  phone_number: Scalars["String"]["input"];
};

export enum RegisterTypeEnum {
  Admin = "ADMIN",
  Email = "EMAIL",
  Facebook = "FACEBOOK",
  Google = "GOOGLE",
}

export type RemoveWorkerFromLocalizationDto = {
  localizationId: Scalars["String"]["input"];
};

/** Payload for creating replacement checkout. */
export type ReplacementCheckoutInput = {
  attributes: Array<InputMaybe<OrderAttributePayload>>;
  paymentMethodId?: InputMaybe<Scalars["String"]["input"]>;
  services: Array<InputMaybe<OrderServicePayload>>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Reservation = {
  /** Snapshot of address attached to reservation, this can be custom address provided by customer at the checkout process or address from given property in a specific time in past. */
  address: Address;
  adminNote?: Maybe<Scalars["String"]["output"]>;
  attributes: Array<Maybe<OrderAttribute>>;
  bundle: Bundle;
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  customPrice: Scalars["Boolean"]["output"];
  customerId: Scalars["String"]["output"];
  customerNote?: Maybe<Scalars["String"]["output"]>;
  cycle?: Maybe<Scalars["Int"]["output"]>;
  discounts?: Maybe<Array<OrderDiscount>>;
  endDate: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  laborPrice: Scalars["Int"]["output"];
  locationId: Scalars["String"]["output"];
  orderHouseArea?: Maybe<OrderHouseArea>;
  /** IDs of order's parent which is provided in case order was changed or replaced by other order. If such entity contains a originOrderReferenceId this means this is a revision of the original order. */
  originOrderReferenceId?: Maybe<Scalars["String"]["output"]>;
  /**
   * The 'paymentMethodId' is a unique identifier for the PaymentMethod provided by Stripe.
   *   This identifier is used in the 'confirmCheckout' method to confirm the payment method chosen by the user.
   *   The 'paymentMethodId' is often synchronized with the stripePaymentMethodId in the Payment entity related to a specific reservation ('Reservation.payment'). For the cash payments this field should have 'cash' value.
   */
  paymentMethodId: Scalars["String"]["output"];
  /** Periodicity in case reservation should always indicate single-time reservation. */
  periodicity: OrderPeriodicity;
  /** Photos submitted by a worker on reservation */
  photos?: Maybe<Array<Maybe<ReservationPhoto>>>;
  price: Scalars["Int"]["output"];
  processingFees?: Maybe<Array<OrderProcessingFee>>;
  propertyId: Scalars["String"]["output"];
  services: Array<Maybe<OrderService>>;
  startDate: Scalars["DateTime"]["output"];
  status: ReservationStatus;
  subscription?: Maybe<Subscription>;
  /** Time consumption is a filed represented by ISO-8601 duration string. Commonly it indicates how much time it take to perform specific task. */
  timeConsumption: Scalars["String"]["output"];
  workers: Array<Maybe<Profile>>;
};

export type ReservationCustomer = {
  avatar?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  phone: Scalars["String"]["output"];
};

export type ReservationFilter = {
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<Array<ReservationStatus>>;
};

export type ReservationPhoto = {
  file: File;
};

/** Enumeration for the various statuses an order can undergo in the reservation system. */
export enum ReservationStatus {
  /** The reservation has been reviewed and accepted by the customer. */
  Accepted = "ACCEPTED",
  /** The order has been assigned to a worker, but work has not commenced. */
  Assigned = "ASSIGNED",
  /** The order is awaiting payment completion from the customer. */
  AwaitingPayment = "AWAITING_PAYMENT",
  /** The order has been cancelled by the customer. */
  Cancelled = "CANCELLED",
  /** The reservation is finalized. The work is completed, and payment is received from the customer. */
  Completed = "COMPLETED",
  CustomerReview = "CUSTOMER_REVIEW",
  PaymentFailed = "PAYMENT_FAILED",
  PaymentReceived = "PAYMENT_RECEIVED",
  /** The order has been created but has not yet been assigned to any worker. */
  Pending = "PENDING",
  /** The payment for the order has been refunded by the administration. */
  Refunded = "REFUNDED",
  /** The reservation has been reviewed and rejected by the customer. The order will revert to the "WORK_STARTED" state shortly. */
  Rejected = "REJECTED",
  /** The order has been deliberately modified by the customer. The original order is no longer valid and has been superseded by a new order. */
  Replaced = "REPLACED",
  /** The worker has initiated work on the order. */
  WorkStarted = "WORK_STARTED",
}

/** Reservation is immutable entity that represents connection of customer, property and services with a worker at specific time. This ObjectType is a View Model representing Reservation entity, in near future it will completely replace Reservation ObjectType which was not possible in November 2023 due to coupling between administrator application and storefront application. */
export type ReservationVm = {
  /** Snapshot of address attached to reservation, this can be custom address provided by customer at the checkout process or address from given property in a specific time in past. */
  address: Address;
  adminNote: Scalars["String"]["output"];
  attributes: Array<Maybe<OrderAttribute>>;
  bundle: Bundle;
  completionPhotos?: Maybe<Array<ReservationPhoto>>;
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  customer: ReservationCustomer;
  customerNote: Scalars["String"]["output"];
  cycle?: Maybe<Scalars["Int"]["output"]>;
  discounts?: Maybe<Array<OrderDiscount>>;
  endDate: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  /** Represents revenue for individual worker who is participating in given reservation. */
  individualWorkerRevenueAmount: Scalars["Int"]["output"];
  /** Time consumption for individual worker. */
  individualWorkerWorkDuration: Scalars["String"]["output"];
  laborPrice: Scalars["Int"]["output"];
  locationId: Scalars["String"]["output"];
  orderHouseArea?: Maybe<OrderHouseArea>;
  payment?: Maybe<Payment>;
  /** Represents stripe payment method or can have value 'cash' for cash payments. */
  paymentMethodId: Scalars["String"]["output"];
  /** Periodicity in case reservation should always indicate single-time reservation. */
  periodicity: OrderPeriodicity;
  price: Scalars["Int"]["output"];
  processingFees?: Maybe<Array<OrderProcessingFee>>;
  propertyId: Scalars["String"]["output"];
  review?: Maybe<Review>;
  services: Array<Maybe<OrderService>>;
  shouldUseDiscount: Scalars["Boolean"]["output"];
  startDate: Scalars["DateTime"]["output"];
  status: ReservationStatus;
  subscription?: Maybe<Subscription>;
  /** Time consumption is a filed represented by ISO-8601 duration string. Commonly it indicates how much time it take to perform specific task. */
  timeConsumption: Scalars["String"]["output"];
  workers: Array<Maybe<ReservationWorker>>;
};

export type ReservationWorker = {
  avatar?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  experience?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  phone: Scalars["String"]["output"];
  /** Represents revenue for individual worker who is participating in given reservation. */
  reservationRevenueAmount?: Maybe<Scalars["Int"]["output"]>;
  reservationRevenueCurrency?: Maybe<Scalars["String"]["output"]>;
  /** Time consumption for individual worker. */
  reservationWorkDuration: Scalars["String"]["output"];
};

/** Review */
export type Review = {
  bundleId: Scalars["String"]["output"];
  comment: Scalars["String"]["output"];
  customerEmail: Scalars["String"]["output"];
  customerId: Scalars["ID"]["output"];
  customerName: Scalars["String"]["output"];
  customerProfilePhoto?: Maybe<Scalars["String"]["output"]>;
  /** Czy stosował się do twoich zaleceń? */
  followedInstructions?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  orderId: Scalars["String"]["output"];
  postedAt: Scalars["DateTime"]["output"];
  /** Rating represents a number of stars added to a review, from 1 to 5 */
  rating: Scalars["Int"]["output"];
  reservationCity: Scalars["String"]["output"];
  reservationStartedAt: Scalars["DateTime"]["output"];
  /** Czy powinien przyjść ponownie? */
  shouldComeAgain?: Maybe<Scalars["Boolean"]["output"]>;
  title: Scalars["String"]["output"];
  /** Czy był na czas */
  wasOnTime?: Maybe<Scalars["Boolean"]["output"]>;
  /** Czy był ubrany odpowiednio */
  wasProperlyDressed?: Maybe<Scalars["Boolean"]["output"]>;
  /** Reviews must be duplicated for each worker in current state of system. */
  workerId?: Maybe<Scalars["String"]["output"]>;
};

/** reviews admin model */
export type ReviewAdminModel = {
  bundleId: Scalars["String"]["output"];
  comment: Scalars["String"]["output"];
  customerEmail: Scalars["String"]["output"];
  customerId: Scalars["ID"]["output"];
  customerName: Scalars["String"]["output"];
  customerProfilePhoto?: Maybe<Scalars["String"]["output"]>;
  /** Czy stosował się do twoich zaleceń? */
  followedInstructions?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  orderId: Scalars["String"]["output"];
  postedAt: Scalars["DateTime"]["output"];
  /** Rating represents a number of stars added to a review, from 1 to 5 */
  rating: Scalars["Int"]["output"];
  reservationCity: Scalars["String"]["output"];
  reservationStartedAt: Scalars["DateTime"]["output"];
  /** Czy powinien przyjść ponownie? */
  shouldComeAgain?: Maybe<Scalars["Boolean"]["output"]>;
  title: Scalars["String"]["output"];
  /** Czy był na czas */
  wasOnTime?: Maybe<Scalars["Boolean"]["output"]>;
  /** Czy był ubrany odpowiednio */
  wasProperlyDressed?: Maybe<Scalars["Boolean"]["output"]>;
  workerEmail?: Maybe<Scalars["String"]["output"]>;
  /** Reviews must be duplicated for each worker in current state of system. */
  workerId?: Maybe<Scalars["String"]["output"]>;
};

export type ReviewAggregateFilter = {
  and?: InputMaybe<Array<ReviewAggregateFilter>>;
  bundleId?: InputMaybe<StringFieldComparison>;
  customerId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ReviewAggregateFilter>>;
  rating?: InputMaybe<ReviewRatingFilterComparison>;
  reservationStartedAt?: InputMaybe<DateFieldComparison>;
  workerId?: InputMaybe<ReviewWorkerIdFilterComparison>;
};

export type ReviewAggregateGroupBy = {
  bundleId?: Maybe<Scalars["String"]["output"]>;
  customerId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reservationStartedAt?: Maybe<Scalars["DateTime"]["output"]>;
  workerId?: Maybe<Scalars["String"]["output"]>;
};

export type ReviewAggregateGroupByReservationStartedAtArgs = {
  by?: GroupBy;
};

export type ReviewAggregateResponse = {
  avg?: Maybe<ReviewAvgAggregate>;
  count?: Maybe<ReviewCountAggregate>;
  groupBy?: Maybe<ReviewAggregateGroupBy>;
  max?: Maybe<ReviewMaxAggregate>;
  min?: Maybe<ReviewMinAggregate>;
  sum?: Maybe<ReviewSumAggregate>;
};

export type ReviewAverageResult = {
  average: Scalars["Float"]["output"];
  completedCleanings: Scalars["Int"]["output"];
  fiveStarCount: Scalars["Int"]["output"];
  fourStarCount: Scalars["Int"]["output"];
  oneStarCount: Scalars["Int"]["output"];
  threeStarCount: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
  twoStarCount: Scalars["Int"]["output"];
};

export type ReviewAvgAggregate = {
  rating?: Maybe<Scalars["Float"]["output"]>;
};

export type ReviewConnection = {
  /** Array of edges. */
  edges: Array<ReviewEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ReviewCountAggregate = {
  bundleId?: Maybe<Scalars["Int"]["output"]>;
  customerId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reservationStartedAt?: Maybe<Scalars["Int"]["output"]>;
  workerId?: Maybe<Scalars["Int"]["output"]>;
};

export type ReviewEdge = {
  /** Cursor for this node. */
  cursor: Scalars["ConnectionCursor"]["output"];
  /** The node containing the Review */
  node: Review;
};

export type ReviewFilter = {
  and?: InputMaybe<Array<ReviewFilter>>;
  bundleId?: InputMaybe<StringFieldComparison>;
  customerId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ReviewFilter>>;
  rating?: InputMaybe<ReviewRatingFilterComparison>;
  reservationStartedAt?: InputMaybe<DateFieldComparison>;
  workerId?: InputMaybe<ReviewWorkerIdFilterComparison>;
};

export type ReviewMaxAggregate = {
  bundleId?: Maybe<Scalars["String"]["output"]>;
  customerId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reservationStartedAt?: Maybe<Scalars["DateTime"]["output"]>;
  workerId?: Maybe<Scalars["String"]["output"]>;
};

export type ReviewMinAggregate = {
  bundleId?: Maybe<Scalars["String"]["output"]>;
  customerId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reservationStartedAt?: Maybe<Scalars["DateTime"]["output"]>;
  workerId?: Maybe<Scalars["String"]["output"]>;
};

export type ReviewPayload = {
  comment: Scalars["String"]["input"];
  /** Czy stosował się do twoich zaleceń? */
  followedInstructions?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderId: Scalars["String"]["input"];
  rating: Scalars["Int"]["input"];
  /** Czy powinien przyjść ponownie? */
  shouldComeAgain?: InputMaybe<Scalars["Boolean"]["input"]>;
  title: Scalars["String"]["input"];
  /** Czy był na czas */
  wasOnTime?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Czy był ubrany odpowiednio */
  wasProperlyDressed?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReviewRatingFilterComparison = {
  eq?: InputMaybe<Scalars["Int"]["input"]>;
  gt?: InputMaybe<Scalars["Int"]["input"]>;
  gte?: InputMaybe<Scalars["Int"]["input"]>;
  lt?: InputMaybe<Scalars["Int"]["input"]>;
  lte?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ReviewSort = {
  direction: SortDirection;
  field: ReviewSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ReviewSortFields {
  BundleId = "bundleId",
  CustomerId = "customerId",
  Id = "id",
  Rating = "rating",
  ReservationStartedAt = "reservationStartedAt",
  WorkerId = "workerId",
}

export type ReviewSumAggregate = {
  rating?: Maybe<Scalars["Float"]["output"]>;
};

export type ReviewWorkerIdFilterComparison = {
  eq?: InputMaybe<Scalars["String"]["input"]>;
};

export type Service = {
  additionalDescription: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  icon: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  /** Defines if service is discountable by subscription */
  isSubscriptionDiscountApplicable?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  variants: Array<ServiceVariant>;
};

export type ServiceTemplate = {
  additionalDescription: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  icon: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  /** Defines if service is discountable by subscription */
  isSubscriptionDiscountApplicable?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  variants: Array<ServiceVariantsTemplate>;
};

export type ServiceVariant = {
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  isFree: Scalars["Boolean"]["output"];
  price: Scalars["Int"]["output"];
  timeConsumption: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type ServiceVariantIsFreeArgs = {
  bundleId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ServiceVariantsTemplate = {
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  price: Scalars["Int"]["output"];
  timeConsumption: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

/** slots for availability calendar model */
export type SlotsModel = {
  endTime?: Maybe<Scalars["DateTime"]["output"]>;
  slotTime?: Maybe<Scalars["String"]["output"]>;
  startTime?: Maybe<Scalars["DateTime"]["output"]>;
};

export type SolveAuthorizationChallengeInput = {
  code: Scalars["String"]["input"];
  phone_number: Scalars["String"]["input"];
};

/** Sort Directions */
export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}

/** Sort Nulls Options */
export enum SortNulls {
  NullsFirst = "NULLS_FIRST",
  NullsLast = "NULLS_LAST",
}

/** StoredDiscount represents a discount in user's wallet, a one is snapshot of discount when was added by user. */
export type StoredDiscount = {
  code: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  profileId: Scalars["ID"]["output"];
  state: DiscountState;
  type: StoredDiscountType;
  value: Scalars["Int"]["output"];
};

export enum StoredDiscountType {
  Coupon = "COUPON",
  Referral = "REFERRAL",
  Voucher = "VOUCHER",
}

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  iLike?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<Scalars["String"]["input"]>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  neq?: InputMaybe<Scalars["String"]["input"]>;
  notILike?: InputMaybe<Scalars["String"]["input"]>;
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
  notLike?: InputMaybe<Scalars["String"]["input"]>;
};

export type SubmitPayoutInput = {
  amount: Scalars["Int"]["input"];
};

export type Subscription = {
  address: Address;
  adminNote?: Maybe<Scalars["String"]["output"]>;
  attributes: Array<OrderAttribute>;
  bundle: Bundle;
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  customPrice: Scalars["Boolean"]["output"];
  customerId: Scalars["String"]["output"];
  customerNote?: Maybe<Scalars["String"]["output"]>;
  discounts?: Maybe<Array<OrderDiscount>>;
  houseArea?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["String"]["output"];
  iterations?: Maybe<Array<Reservation>>;
  laborPrice: Scalars["Int"]["output"];
  locationId: Scalars["String"]["output"];
  orderHouseArea?: Maybe<OrderHouseArea>;
  paymentMethodId?: Maybe<Scalars["String"]["output"]>;
  paymentMethodType?: Maybe<Scalars["String"]["output"]>;
  periodicity: OrderPeriodicity;
  price: Scalars["Int"]["output"];
  propertyId: Scalars["String"]["output"];
  services: Array<OrderService>;
  startDate: Scalars["DateTime"]["output"];
  status: SubscriptionStatus;
  /** Time consumption is a filed represented by ISO-8601 duration string. Commonly it indicates how much time it take to perform specific task. */
  timeConsumption: Scalars["String"]["output"];
};

export type SubscriptionOption = {
  /** Example: 'Subscribe weekly and save 10%' */
  description: Scalars["String"]["output"];
  /** Discount field which represents percentage discount on specific subscription option, it's value is between 1 and 100. */
  discount: Scalars["Int"]["output"];
  duration: Scalars["String"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  /** Example: 'Weekly' */
  title: Scalars["String"]["output"];
};

export type SubscriptionOptionTemplate = {
  description: Scalars["String"]["output"];
  discount: Scalars["Int"]["output"];
  duration: Scalars["Int"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

/** Order processing fee happens in various cases in our application, this can be modification of reservation after specific time or cancellation of offer. This fee is not refundable. */
export type SubscriptionProcessingFee = {
  amount: Scalars["Int"]["output"];
  currency: Scalars["String"]["output"];
  promoCode: Scalars["String"]["output"];
  promoCodeAlreadyUsed: Scalars["Boolean"]["output"];
  type: ProcessingFeeType;
};

export enum SubscriptionStatus {
  Active = "ACTIVE",
  Cancelled = "CANCELLED",
}

export type Swap = {
  fromReservation: ReservationVm;
  id: Scalars["ID"]["output"];
  /** Payment is not required as reservation changes may be free of charge under specific circumstances. */
  payment?: Maybe<Payment>;
  /** Field represents newly created reservation, this field is considered nullable because if the payment exists it must be completed before reservation will be created. */
  toReservation?: Maybe<ReservationVm>;
};

/** Declared Swap which can be in state which requires action or is completed because payment did not required 3DS or was not required at all. */
export type SwapDeclared = NotFulfilledSwap | SwapRequiresAction;

export type SwapRequiresAction = Swap & {
  fromReservation: ReservationVm;
  id: Scalars["ID"]["output"];
  /** Swap in this state must contain Payment with NextAction */
  payment: Payment;
  /** Created reservation is always null in this state. */
  toReservation?: Maybe<ReservationVm>;
};

export type UpdateCustomerProfileInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  newsletterNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  pushNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  smsNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateProfileImageInput = {
  image?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePropertyInput = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  doorCode?: InputMaybe<Scalars["String"]["input"]>;
  floorArea?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  postalOrZipCode?: InputMaybe<Scalars["String"]["input"]>;
  propertyId: Scalars["String"]["input"];
  setDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  streetAddress1?: InputMaybe<Scalars["String"]["input"]>;
  streetAddress2?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<ApartmentType>;
};

export type UpdateWorkerCalendarInput = {
  friday?: InputMaybe<CalendarDatesHelperInput>;
  monday?: InputMaybe<CalendarDatesHelperInput>;
  saturday?: InputMaybe<CalendarDatesHelperInput>;
  sunday?: InputMaybe<CalendarDatesHelperInput>;
  thursday?: InputMaybe<CalendarDatesHelperInput>;
  tuesday?: InputMaybe<CalendarDatesHelperInput>;
  wednesday?: InputMaybe<CalendarDatesHelperInput>;
};

export type UpdateWorkerProfileInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  experience?: InputMaybe<Scalars["String"]["input"]>;
  newsletterNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  pushNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  smsNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  workerAddress: CreateOrUpdateWorkerAddressInput;
};

export type UploadDocumentForVerificationInput = {
  documentBack?: InputMaybe<Scalars["String"]["input"]>;
  documentFront?: InputMaybe<Scalars["String"]["input"]>;
  passportBack?: InputMaybe<Scalars["String"]["input"]>;
  passportFront?: InputMaybe<Scalars["String"]["input"]>;
  verificationType: VerificationTypeEum;
};

export type UserBalance = {
  balance: Scalars["Int"]["output"];
  currency: Scalars["String"]["output"];
};

export type ValidateAddressInLocalizationInput = {
  city: Scalars["String"]["input"];
  localizationId: Scalars["String"]["input"];
  postalOrZipCode: Scalars["String"]["input"];
  streetAddress1: Scalars["String"]["input"];
  streetAddress2?: InputMaybe<Scalars["String"]["input"]>;
};

export enum VerificationStatusEnum {
  Rejected = "REJECTED",
  Unverified = "UNVERIFIED",
  Verified = "VERIFIED",
}

export enum VerificationTypeEum {
  IdCardAndAdditionalDocument = "ID_CARD_AND_ADDITIONAL_DOCUMENT",
  IdCardAndDriverLicense = "ID_CARD_AND_DRIVER_LICENSE",
  Passport = "PASSPORT",
}

export type VerifyAccountPhoneNumberInput = {
  code: Scalars["String"]["input"];
  phone_number: Scalars["String"]["input"];
};

export type VerifyCheckoutPaymentMethodInput = {
  checkoutId: Scalars["String"]["input"];
  returnUrl: Scalars["String"]["input"];
};

export type VerifyCheckoutPaymentMethodOutput = {
  /** Indicates if payment method is valid */
  confirmed: Scalars["Boolean"]["output"];
  nextStep?: Maybe<PaymentRedirectStep>;
  requiresAdditionalActions: Scalars["Boolean"]["output"];
};

/** Vouchers */
export type VouchersModel = {
  amount: Scalars["Int"]["output"];
  description: Scalars["String"]["output"];
  enabled: Scalars["Boolean"]["output"];
  expDate?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["String"]["output"];
  isSupplyLimited: Scalars["Boolean"]["output"];
  isTimeLimited: Scalars["Boolean"]["output"];
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  supply: Scalars["Int"]["output"];
  totalApplications: Scalars["Int"]["output"];
  voucherName: Scalars["String"]["output"];
};

/** worker_address  */
export type WorkerAddressModel = {
  city: Scalars["String"]["output"];
  extraInformation?: Maybe<Scalars["String"]["output"]>;
  latitude?: Maybe<Scalars["Int"]["output"]>;
  longitude?: Maybe<Scalars["Int"]["output"]>;
  postalOrZipCode: Scalars["String"]["output"];
  streetAddress1: Scalars["String"]["output"];
  streetAddress2?: Maybe<Scalars["String"]["output"]>;
};

/** worker day offs */
export type WorkerDayOffsProfileModel = {
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
};

/** WorkerMetadata */
export type WorkerMetadata = {
  address?: Maybe<WorkerAddressModel>;
  experience?: Maybe<Scalars["String"]["output"]>;
  payoutsMetadata?: Maybe<PayoutsMetadataModel>;
  stats?: Maybe<WorkerStatsModel>;
  trainingVerificationStatus: VerificationStatusEnum;
  workerDayOffs?: Maybe<Array<WorkerDayOffsProfileModel>>;
  workerWorkingHours?: Maybe<WorkerWorkingHoursProfileModel>;
};

/** WorkerStatsModel */
export type WorkerStatsModel = {
  avgReview?: Maybe<Scalars["String"]["output"]>;
  currentStripeBalance?: Maybe<Scalars["Int"]["output"]>;
  incomingTotalHours?: Maybe<Scalars["String"]["output"]>;
  totalHours?: Maybe<Scalars["String"]["output"]>;
  totalHoursInPast?: Maybe<Scalars["String"]["output"]>;
  totalHoursInThisMonth?: Maybe<Scalars["String"]["output"]>;
  totalStripeBalance?: Maybe<Scalars["Int"]["output"]>;
  totalSystemBalance?: Maybe<Scalars["Int"]["output"]>;
};

/** WorkerTimeStatsModel */
export type WorkerTimeStatsModel = {
  antepenultimateMontTotalHours?: Maybe<Scalars["String"]["output"]>;
  previousMonthTotalHours?: Maybe<Scalars["String"]["output"]>;
  totalHoursInThisMonth?: Maybe<Scalars["String"]["output"]>;
};

/** worker working hours */
export type WorkerWorkingHoursProfileHelper = {
  endTime?: Maybe<Scalars["String"]["output"]>;
  startTime?: Maybe<Scalars["String"]["output"]>;
};

/** worker working hours */
export type WorkerWorkingHoursProfileModel = {
  friday?: Maybe<WorkerWorkingHoursProfileHelper>;
  monday?: Maybe<WorkerWorkingHoursProfileHelper>;
  saturday?: Maybe<WorkerWorkingHoursProfileHelper>;
  sunday?: Maybe<WorkerWorkingHoursProfileHelper>;
  thursday?: Maybe<WorkerWorkingHoursProfileHelper>;
  tuesday?: Maybe<WorkerWorkingHoursProfileHelper>;
  wednesday?: Maybe<WorkerWorkingHoursProfileHelper>;
};

export type CalendarDatesHelperInput = {
  endTime: Scalars["String"]["input"];
  startTime: Scalars["String"]["input"];
};

export type V1JobOffersPaginatedViewModel = {
  jobOffers: Array<JobOffer>;
  limit: Scalars["Int"]["output"];
  page: Scalars["Int"]["output"];
  totalPages: Scalars["Int"]["output"];
  totalRecords: Scalars["Int"]["output"];
};

export type V2Address = {
  city: Scalars["String"]["output"];
  doorCode?: Maybe<Scalars["String"]["output"]>;
  floorArea?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  postalOrZipCode: Scalars["String"]["output"];
  streetAddress1: Scalars["String"]["output"];
  streetAddress2?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<ApartmentType>;
};

export type V2AddressUpsertInput = {
  city: Scalars["String"]["input"];
  doorCode?: InputMaybe<Scalars["String"]["input"]>;
  floorArea?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  postalOrZipCode: Scalars["String"]["input"];
  streetAddress1: Scalars["String"]["input"];
  streetAddress2?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<ApartmentType>;
};

export type V2BillingAddress = {
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  line1?: Maybe<Scalars["String"]["output"]>;
  line2?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  postal_code?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  taxIdentification?: Maybe<Scalars["String"]["output"]>;
};

export type V2BillingAddressUpsertInput = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  line1?: InputMaybe<Scalars["String"]["input"]>;
  line2?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  postal_code?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  taxIdentification?: InputMaybe<Scalars["String"]["input"]>;
};

export type V2Bonus = {
  appliesTo: ProfileTypeEnum;
  createdAt: Scalars["DateTime"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  reward: Scalars["Int"]["output"];
  slug: Scalars["String"]["output"];
  timeLimitDate?: Maybe<Scalars["DateTime"]["output"]>;
  timeLimited: Scalars["Boolean"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  usageLimit?: Maybe<Scalars["Int"]["output"]>;
  usageLimited: Scalars["Boolean"]["output"];
};

export type V2Bundle = {
  additionalDescription: Scalars["String"]["output"];
  additionalTitle: Scalars["String"]["output"];
  bannerRedirection: Scalars["String"]["output"];
  categories: Array<V2BundleQuestionCategory>;
  categoryType: CategoryType;
  checkList: Array<V2BundleCheckList>;
  currency: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  desktopBanner: Scalars["String"]["output"];
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  houseArea?: Maybe<V2BundleHouseAreaModel>;
  id: Scalars["String"]["output"];
  isAdditionalTitleAndDescriptionEnabled: Scalars["Boolean"]["output"];
  isBanner: Scalars["Boolean"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  isHouseAreaEnabled: Scalars["Boolean"]["output"];
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  laborPrice?: Maybe<Scalars["Int"]["output"]>;
  localizationId: Scalars["String"]["output"];
  minimumOrderValue?: Maybe<Scalars["Int"]["output"]>;
  minimumOrderValueEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  mobileBanner: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  questions: Array<V2BundleQuestion>;
  services: Array<V2BundleAdditional>;
  slug: Scalars["String"]["output"];
  startingPrice: Scalars["Int"]["output"];
  subscriptionOptions: Array<V2BundleSubscriptionOption>;
};

export type V2BundleAdditional = {
  additionalDescription: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  icon: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isSubscriptionDiscountApplicable: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  variants: Array<V2BundleAdditionalVariant>;
};

export type V2BundleAdditionalVariant = {
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  isFree: Scalars["Boolean"]["output"];
  price: Scalars["Int"]["output"];
  timeConsumption: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type V2BundleAdditionalVariantIsFreeArgs = {
  bundleId?: InputMaybe<Scalars["String"]["input"]>;
};

export type V2BundleCheckList = {
  description: Scalars["String"]["output"];
  iconUrl: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

export type V2BundleHouseAreaModel = {
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  steps: Array<V2BundleHouseAreaStepModel>;
  subscriptionDiscount: Scalars["Boolean"]["output"];
};

export type V2BundleHouseAreaStepModel = {
  from: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  price: Scalars["Int"]["output"];
  to: Scalars["Int"]["output"];
};

export type V2BundleQuestion = {
  additionalDescription: Scalars["String"]["output"];
  answers: Array<V2BundleQuestionAnswer>;
  description?: Maybe<Scalars["String"]["output"]>;
  enabled: Scalars["Boolean"]["output"];
  iconUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  isRequired: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  numericType?: Maybe<NumericType>;
  position: Scalars["Int"]["output"];
  subscriptionDiscount: Scalars["Boolean"]["output"];
  type: AttributeType;
  wysiwygDescription: Scalars["String"]["output"];
};

export type V2BundleQuestionAnswer = {
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  isPriceFixed: Scalars["Boolean"]["output"];
  isSalaryEnabled: Scalars["Boolean"]["output"];
  isSubscriptionDiscountEnabled: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  price: Scalars["Int"]["output"];
  salary: Scalars["Int"]["output"];
  timeConsumption: Scalars["String"]["output"];
};

export type V2BundleQuestionCategory = {
  carousel: Array<V2BundleQuestionCategoryCarousel>;
  description: Scalars["String"]["output"];
  extraDesktopUrl: Scalars["String"]["output"];
  extraMobileUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  position: Scalars["Int"]["output"];
  questions: Array<V2BundleQuestion>;
  title: Scalars["String"]["output"];
};

export type V2BundleQuestionCategoryCarousel = {
  desktopUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  mobileUrl: Scalars["String"]["output"];
};

export type V2BundleSubscriptionOption = {
  description: Scalars["String"]["output"];
  discount: Scalars["Int"]["output"];
  duration: Scalars["String"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type V2CartQuestionsUpsert = {
  attributeId: Scalars["String"]["input"];
  quantity?: InputMaybe<Scalars["Int"]["input"]>;
  valueId: Array<Scalars["String"]["input"]>;
};

export type V2CartServiceVariantsUpsert = {
  quantity: Scalars["Int"]["input"];
  variantId: Scalars["String"]["input"];
};

export type V2CartServicesUpsert = {
  serviceId: Scalars["String"]["input"];
  variants: Array<V2CartServiceVariantsUpsert>;
};

export type V2CategoryCarousel = {
  desktopUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  mobileUrl: Scalars["String"]["output"];
};

export type V2Checkout = {
  address?: Maybe<V2Address>;
  attributes: Array<V2CheckoutBundleAttributes>;
  billingAddress?: Maybe<V2BillingAddress>;
  bundle: V2Bundle;
  couponCode?: Maybe<Scalars["String"]["output"]>;
  currency: Scalars["String"]["output"];
  customerNote?: Maybe<Scalars["String"]["output"]>;
  discounts?: Maybe<Array<V2CheckoutDiscount>>;
  fingerprint?: Maybe<Scalars["String"]["output"]>;
  houseArea?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["String"]["output"];
  locationId: Scalars["String"]["output"];
  orderHouseArea?: Maybe<V2CheckoutHouseArea>;
  paymentMethodId?: Maybe<Scalars["String"]["output"]>;
  periodicity?: Maybe<V2CheckoutPeriodicity>;
  priceAfterDiscounts: Scalars["Int"]["output"];
  processingFees?: Maybe<Array<V2CheckoutProcessingFee>>;
  propertyId?: Maybe<Scalars["String"]["output"]>;
  services: Array<V2CheckoutBundleServices>;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  timeConsumption: Scalars["String"]["output"];
  totalPrice: Scalars["Int"]["output"];
  useVirtualWallet?: Maybe<Scalars["Boolean"]["output"]>;
};

export type V2CheckoutBundleAttributes = {
  attribute: V2BundleQuestion;
  currency: Scalars["String"]["output"];
  discount?: Maybe<Array<V2CheckoutDiscount>>;
  price: Scalars["Int"]["output"];
  quantity?: Maybe<Scalars["Float"]["output"]>;
  timeConsumption?: Maybe<Scalars["String"]["output"]>;
  values: Array<V2BundleQuestionAnswer>;
};

export type V2CheckoutBundleServiceVariant = {
  currency: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  isFree?: Maybe<Scalars["String"]["output"]>;
  price: Scalars["Int"]["output"];
  quantity: Scalars["Int"]["output"];
  sumPrice: Scalars["Int"]["output"];
  sumTimeConsumption: Scalars["String"]["output"];
  timeConsumption: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  variantId: Scalars["String"]["output"];
};

export type V2CheckoutBundleServices = {
  currency: Scalars["String"]["output"];
  discount?: Maybe<Array<V2CheckoutDiscount>>;
  price: Scalars["Int"]["output"];
  service: V2BundleAdditional;
  timeConsumption: Scalars["String"]["output"];
  variants: Array<V2CheckoutBundleServiceVariant>;
};

export type V2CheckoutDiscount = {
  fixedValue: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  type: Order_Discount_Type;
};

export type V2CheckoutHouseArea = {
  discount?: Maybe<Array<V2CheckoutDiscount>>;
  houseAreaAttributeId: Scalars["String"]["output"];
  houseAreaStepId: Scalars["String"]["output"];
  price: Scalars["Int"]["output"];
  timeConsumption: Scalars["String"]["output"];
};

export type V2CheckoutPeriodicity = {
  cycleDuration: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  discount?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type V2CheckoutProcessingFee = {
  amount: Scalars["Int"]["output"];
  currency: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  type: Processing_Fee_Type;
};

export type V2CustomerProfile = {
  color?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  phone: Scalars["String"]["output"];
  stripeId?: Maybe<Scalars["String"]["output"]>;
  tagId?: Maybe<Scalars["String"]["output"]>;
};

export type V2DraftCheckoutInput = {
  address?: InputMaybe<V2AddressUpsertInput>;
  attributes: Array<V2CartQuestionsUpsert>;
  billingAddress?: InputMaybe<V2BillingAddressUpsertInput>;
  bundleId: Scalars["String"]["input"];
  couponCode?: InputMaybe<Scalars["String"]["input"]>;
  customerId?: InputMaybe<Scalars["String"]["input"]>;
  customerNote?: InputMaybe<Scalars["String"]["input"]>;
  fingerPrint?: InputMaybe<Scalars["String"]["input"]>;
  houseArea?: InputMaybe<Scalars["Int"]["input"]>;
  locationId: Scalars["String"]["input"];
  paymentMethodId?: InputMaybe<Scalars["String"]["input"]>;
  propertyId?: InputMaybe<Scalars["String"]["input"]>;
  services: Array<V2CartServicesUpsert>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  subscriptionOptionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type V2HomepageBannerCarousel = {
  desktopUrl: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  mobileUrl: Scalars["String"]["output"];
};

export type V2WorkerProfile = {
  city: Scalars["String"]["output"];
  color?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  phone: Scalars["String"]["output"];
  stripeId?: Maybe<Scalars["String"]["output"]>;
  tagId?: Maybe<Scalars["String"]["output"]>;
  trainingStatus: VerificationStatusEnum;
};
